import type { Clave } from "./es";

/**
 * El programa en alemán: desde 2024 los clubes son legales allí y la ley les da su propio vocabulario.
 *
 * `Record<Clave, string>` es lo que hace que no se pueda olvidar ninguna
 * frase: si es.ts gana una clave y aquí no está, el programa no compila. Es
 * mejor que una prueba, porque salta antes de ejecutar nada.
 */
export const de: Record<Clave, string> = {
  "general.cargando": "Lädt...",
  "general.unMomento": "Einen Moment...",
  "general.guardando": "Wird gespeichert...",
  "general.guardar": "Speichern",
  "general.guardado": "Gespeichert",
  "general.cancelar": "Abbrechen",
  "general.cerrar": "Schließen",
  "general.volver": "Zurück",
  "general.salir": "Abmelden",
  "general.entrar": "Anmelden",
  "general.enviando": "Wird gesendet...",
  "general.idioma": "Sprache",
  "general.o": "oder",
  "general.fallo": "Der Vorgang konnte nicht abgeschlossen werden",

  "titulo.gestion": "Clubverwaltung",
  "titulo.portal": "Mein Club",
  "titulo.carta": "Preistafel",
  "titulo.plataforma": "Plattform-Übersicht",
  "titulo.web": "asocis · Software für Cannabis-Anbauvereinigungen",
  "titulo.prueba": "Test anfragen · asocis",
  "manifiesto.nombre": "Mitgliederbereich",
  "manifiesto.descripcion":
    "Dein Ausweis, dein Verbrauch, dein Beitrag und die Neuigkeiten deines Vereins.",
  "carta.cargando": "Preistafel wird geladen…",
  "carta.noDisponible": "Preistafel nicht verfügbar",
  "carta.noDisponibleAyuda":
    "Prüfe den Link, oder bitte den Club, die Preistafel in den Einstellungen einzuschalten.",
  "carta.sinProducto": "Im Moment ist nichts verfügbar.",
  "carta.pie": "Solidarbeitrag für Mitglieder · Aktualisiert um {hora}",
  "carta.pieSinConexion":
    "Solidarbeitrag für Mitglieder · Aktualisiert um {hora} · keine Verbindung, kann veraltet sein",
  "unidad.dia": "Tag",
  "unidad.dias": "Tage",

  "mov.recarga.EFECTIVO": "Aufladung bar",
  "mov.recarga.TARJETA": "Aufladung Karte",
  "mov.recarga.TRANSFERENCIA": "Aufladung Überweisung",
  "mov.devolucion": "Guthaben zurückgezahlt",
  "mov.dispensacion": "Abgabe #{numero}",
  "mov.dispensacionAnulada": "Abgabe #{numero} storniert",
  "mov.barra": "Tresen #{numero}",
  "mov.barraAnulada": "Tresen #{numero} storniert",
  "mov.donacion": "Spende an den Club",
  "cuota.anual": "Jahresbeitrag",
  "cuota.anios": "Beitrag für {n} Jahre",
  "cuota.unMes": "Beitrag für einen Monat",
  "cuota.meses": "Beitrag für {n} Monate",
  "cuota.alta": "Aufnahmebeitrag",
  "pago.EFECTIVO": "Bar",
  "pago.CARTERA": "Guthabenkonto",
  "pago.TARJETA": "Karte",
  "pago.TRANSFERENCIA": "Überweisung",
  "movimiento.RECARGA": "Aufladung",
  "movimiento.CONSUMO": "Abbuchung",
  "movimiento.DEVOLUCION": "Erstattung",
  "movimiento.AJUSTE": "Korrektur",
  "movimiento.CUOTA": "Mitgliedsbeitrag",
  "genetica.SATIVA": "Sativa",
  "genetica.INDICA": "Indica",
  "genetica.HIBRIDA": "Hybrid",
  "genetica.CBD": "CBD",
  "genetica.NA": "—",

  "portal.cabecera.socioNumero": "{nombre} · Mitglied Nr. {numero}",
  "portal.cabecera.contrasena": "Passwort",
  "portal.pestana.inicio": "Mitgliedsausweis",
  "portal.pestana.catalogo": "Verfügbar",
  "portal.pestana.reservas": "Meine Vorbestellungen",
  "portal.pestana.noticias": "Neuigkeiten",
  "portal.pestana.valoraciones": "Bewerten",
  "portal.pestana.historial": "Mein Verlauf",
  "portal.pestana.contrato": "Vertrag",

  "entrada.titulo": "Mitgliederbereich",
  "entrada.subtituloEntrar": "Sieh dir deine Bezugsmenge, deinen Mitgliedsbeitrag und deinen Mitgliedsausweis an",
  "entrada.subtituloActivar": "Richte deinen Zugang mit dem Code des Clubs ein",
  "entrada.club": "Club",
  "entrada.clubAyuda": "Die Kennung, die dir der Verein gegeben hat.",
  "entrada.numeroSocio": "Mitgliedsnummer",
  "entrada.codigo": "Aktivierungscode",
  "entrada.codigoAyuda": "Den bekommst du an der Theke. Er läuft nach 7 Tagen ab.",
  "entrada.contrasena": "Passwort",
  "entrada.eligeContrasena": "Wähle ein Passwort",
  "entrada.minimo8": "Mindestens 8 Zeichen.",
  "entrada.repiteContrasena": "Passwort wiederholen",
  "entrada.crearAcceso": "Zugang erstellen",
  "entrada.primeraVez": "Zum ersten Mal hier?",
  "entrada.activarAcceso": "Zugang aktivieren",
  "entrada.yaTengoContrasena": "Ich habe schon ein Passwort",
  "entrada.noCoinciden": "Die beiden Passwörter stimmen nicht überein",
  "entrada.accesoCreado": "Zugang erstellt. Du kannst dich jetzt mit deinem Passwort anmelden.",

  "inicio.cuotaVencioHace":
    "Deine Mitgliedschaft ist schon {dias} abgelaufen. Komm im Club vorbei, um sie zu verlängern.",
  "inicio.cuotaVenceHoy": "Deine Mitgliedschaft läuft heute ab.",
  "inicio.cuotaVenceEn": "Deine Mitgliedschaft ist noch {dias} gültig.",
  "inicio.socio": "Mitglied",
  "inicio.numero": "Nr. {numero}",
  "inicio.socioDesde": "Mitglied seit {fecha}",
  "inicio.cuotaValidaHasta": "Mitgliedschaft gültig bis {fecha}",
  "inicio.generando": "Wird erstellt…",
  "inicio.ensenaCodigo": "Zeig diesen Code an der Theke, um dich auszuweisen.",
  "inicio.tuConsumo": "Deine Bezugsmenge",
  "inicio.hoy": "Heute",
  "inicio.esteMes": "Diesen Monat",
  "inicio.puedesRetirar": "Du kannst jetzt beziehen",
  "inicio.tuCartera": "Dein Guthabenkonto",
  "inicio.saldoDisponible": "Verfügbares Guthaben für deine Pauschalen. Aufgeladen wird an der Theke.",
  "inicio.tuClub": "Dein Club",
  "inicio.telefono": "Telefon:",

  "avisos.titulo": "Benachrichtigungen des Clubs",
  "avisos.noSoportado":
    "Dieser Browser unterstützt keine Benachrichtigungen. Die Neuigkeiten kannst du im Mitgliederbereich nachlesen.",
  "avisos.requiereInstalar1":
    "Auf dem iPhone musst du den Mitgliederbereich erst zum Home-Bildschirm hinzufügen: tippe auf",
  "avisos.compartir": "Teilen",
  "avisos.yLuego": "und dann",
  "avisos.anadirAInicio": "Zum Home-Bildschirm",
  "avisos.requiereInstalar2": "Danach kannst du die Benachrichtigungen hier aktivieren.",
  "avisos.activados":
    "Du bekommst auf diesem Gerät eine Benachrichtigung, wenn der Club eine Neuigkeit veröffentlicht.",
  "avisos.sinActivar":
    "Aktiviere die Benachrichtigungen, um Neuigkeiten aus dem Club mitzubekommen, ohne dich anzumelden.",
  "avisos.desactivar": "Benachrichtigungen deaktivieren",
  "avisos.activar": "Benachrichtigungen aktivieren",
  "avisos.enviarPrueba": "Test senden",
  "avisos.yaNo": "Du bekommst auf diesem Gerät keine Benachrichtigungen mehr.",
  "avisos.listo": "Fertig. Wir benachrichtigen dich, wenn der Club etwas veröffentlicht.",
  "avisos.bloqueados":
    "Dein Browser blockiert die Benachrichtigungen für diese Seite. In seinen Einstellungen kannst du sie wieder freigeben.",
  "avisos.fallo": "Die Benachrichtigungen konnten nicht aktiviert werden. Versuch es später noch einmal.",
  "avisos.pruebaEnviada": "Test-Benachrichtigung gesendet: Sie sollte in ein paar Sekunden ankommen.",
  "avisos.pruebaFallo": "Die Test-Benachrichtigung konnte nicht gesendet werden.",

  "catalogo.vacio": "Der Club hat gerade keine Produkte veröffentlicht.",
  "catalogo.condiciones":
    "In den Pauschalen sind deine Konditionen als Mitglied schon eingerechnet. Die Verfügbarkeit kann sich im Lauf des Tages ändern.",
  "catalogo.sinSaldo":
    "Zum Vorbestellen brauchst du Guthaben. Komm im Club vorbei, um dein Guthabenkonto aufzuladen, dann kannst du von hier aus bestellen.",
  "catalogo.sinStock": "Kein Bestand",
  "catalogo.quitarGramo": "Ein Gramm weniger",
  "catalogo.anadirGramo": "Ein Gramm mehr",
  "catalogo.faltan": "Dir fehlen {importe} auf dem Guthabenkonto",
  "catalogo.quedarian": "Dir blieben {importe} auf dem Guthabenkonto",
  "catalogo.vaciar": "Leeren",
  "catalogo.reservar": "Vorbestellen",
  "catalogo.reservando": "Vorbestellung läuft...",
  "catalogo.falloReserva": "Die Vorbestellung konnte nicht aufgegeben werden",
  "reservas.vacio":
    "Du hast noch nichts vorbestellt. Unter «Verfügbar» kannst du bestellen, was du möchtest, und es dann abholen.",
  "reservas.titulo": "Vorbestellung {numero}",
  "reservas.PENDIENTE": "Ausstehend",
  "reservas.PENDIENTE.explica": "Der Club hat sie noch nicht vorbereitet.",
  "reservas.PREPARADA": "Bereit",
  "reservas.PREPARADA.explica": "Sie liegt bereit. Komm sie abholen.",
  "reservas.ENTREGADA": "Abgegeben",
  "reservas.ENTREGADA.explica": "Abgeholt.",
  "reservas.CANCELADA": "Storniert",
  "reservas.CADUCADA": "Abgelaufen",
  "reservas.CADUCADA.explica": "Die Frist ist abgelaufen, ohne dass du sie abgeholt hast.",
  "reservas.total": "Gesamt {cantidad}",
  "reservas.guardadaHasta": "Wird bis zum {fecha} aufbewahrt. Danach verfällt sie von selbst.",
  "reservas.falloCancelar": "Stornieren nicht möglich",

  "noticias.vacio": "Der Club hat noch nichts veröffentlicht.",

  "valoraciones.vacio":
    "Wenn du etwas bezogen hast, kannst du hier sagen, wie es war. Der Club weiß dann, was er wieder besorgt.",
  "valoraciones.intro": "Sag, wie das war, was du bezogen hast. Der Club liest es und weiß, was er wieder besorgt.",
  "valoraciones.nDe5": "{n} von 5",
  "valoraciones.comentario": "Was du sonst noch sagen möchtest (optional)",

  "historial.retiradas": "Deine Bezüge",
  "historial.sinRetiradas": "Du hast noch nichts bezogen.",
  "historial.fecha": "Datum",
  "historial.productos": "Produkte",
  "historial.cantidad": "Menge",
  "historial.aportacion": "Pauschale",
  "historial.anulada": "Storniert",
  "historial.cartera": "Bewegungen auf deinem Guthabenkonto",
  "historial.sinMovimientos": "Keine Bewegungen.",
  "historial.concepto": "Vorgang",
  "historial.importe": "Betrag",
  "historial.saldo": "Guthaben",
  "historial.cuotas": "Deine Mitgliedsbeiträge",
  "historial.sinCuotas": "Keine Mitgliedsbeiträge erfasst.",
  "historial.validaHasta": "Gültig bis",

  "contrato.sinPublicar": "Dein Verein hat hier noch keinen Mitgliedsvertrag veröffentlicht.",
  "contrato.aceptaste": "Du hast",
  "contrato.version": "Version {numero}",
  "contrato.elDia": "am {fecha} angenommen",
  "contrato.esLaQueAplica": ". Sie gilt für dich.",
  "contrato.leeConCalma":
    "Lies ihn in Ruhe. Mit dem Annehmen werden Datum und Version festgehalten, und du kannst ihn hier jederzeit wieder nachlesen.",
  "contrato.versionNueva":
    "Der Verein hat eine neuere Version veröffentlicht. Angenommen hast du weiterhin die von oben; frag vor Ort nach, wenn du die neue annehmen möchtest.",
  "contrato.aceptar": "Ich habe den Vertrag gelesen und nehme ihn an",
  "contrato.falloGuardar": "Konnte nicht gespeichert werden",

  "contrasena.titulo": "Passwort ändern",
  "contrasena.actual": "Aktuelles Passwort",
  "contrasena.nueva": "Neues Passwort",
  "contrasena.repite": "Neues Passwort wiederholen",
  "contrasena.cambiar": "Ändern",
  "contrasena.cambiada": "Passwort geändert.",
  "contrasena.fallo": "Das Passwort konnte nicht geändert werden",

  "alta.titulo": "Aufnahme beantragen",
  "alta.clubNoEncontrado": "Diesen Club finden wir nicht. Prüf den Link, den man dir gegeben hat.",
  "alta.nombre": "Vorname *",
  "alta.apellidos": "Nachname *",
  "alta.documento": "Ausweisdokument",
  "alta.pasaporte": "Reisepass",
  "alta.numero": "Nummer *",
  "alta.fechaNacimiento": "Geburtsdatum *",
  "alta.mayorDeEdad": "Du musst mindestens 18 Jahre alt sein.",
  "alta.telefono": "Telefon",
  "alta.email": "E-Mail",
  "alta.ciudad": "Stadt",
  "alta.avalista": "Nr. des Mitglieds, das für dich bürgt",
  "alta.avalistaAyuda": "Falls dich jemand aus dem Verein vorschlägt.",
  "alta.mensaje": "Nachricht an den Club",
  "alta.consentimiento": "Ich willige ein, dass der Verein meine Daten zur Prüfung dieses Aufnahmeantrags verarbeitet.",
  "alta.consentimientoAyuda": "Wird der Antrag abgelehnt, bleiben deine Daten nur im internen Verzeichnis des Vereins.",
  "alta.enviar": "Antrag senden",
  "alta.yaSoySocio": "Ich bin schon Mitglied",
  "alta.enviada": "Antrag gesendet",
  "alta.enviadaTexto":
    "{club} prüft ihn und meldet sich bei dir. Denk daran, dass die Aufnahme vor Ort abgeschlossen wird, indem du deinen Ausweis vorlegst.",
  "alta.elClub": "Der Club",
  "alta.fallo": "Der Antrag konnte nicht gesendet werden",

  "err.clubNoEncontrado": "Diesen Club finden wir nicht",
  "err.codigoNoValido": "Mitgliedsnummer oder Code stimmt nicht, oder der Code ist abgelaufen",
  "err.entradaIncorrecta": "Mitgliedsnummer oder Passwort stimmt nicht",
  "err.passwordActualMal": "Das aktuelle Passwort stimmt nicht",
  "err.soloLoQueTeLlevaste": "Bewerten kannst du nur, was du bezogen hast",
  "err.sinContrato": "Dieser Club hat noch keinen Mitgliedsvertrag",
  "err.reservaNoEncontrada": "Diese Vorbestellung finden wir nicht",
  "err.reservaNoPendiente": "Diese Vorbestellung ist nicht mehr ausstehend",
  "err.reservaCerrada": "Diese Vorbestellung ist schon abgeschlossen",
  "err.yaTienesReserva":
    "Die Vorbestellung {numero} hast du noch nicht abgeholt. Storniere sie, wenn du etwas anderes bestellen möchtest.",
  "err.productoNoEncontrado": "Dieses Produkt finden wir nicht",
  "err.pasaDelMes":
    "Das ist mehr, als du diesen Monat noch beziehen kannst. Dir bleiben {cantidad}.",
  "err.sinSaldo":
    "Zum Vorbestellen brauchst du Guthaben. Die Vorbestellung kostet {total}, du hast {saldo}. Lad dein Guthabenkonto im Club auf und versuch es dann noch einmal.",
  "err.mayorDeEdad": "Du musst mindestens 18 Jahre alt sein",
  "err.nacimientoNoValido": "Das Geburtsdatum ist ungültig",
  "err.consentimiento": "Bitte willige in die Datenverarbeitung ein",
  "err.idiomaNoExiste": "Diese Sprache gibt es nicht",
  "err.bloqueo.baja": "Deine Mitgliedschaft ist beendet. Wende dich an den Club.",
  "err.bloqueo.suspendido": "Deine Mitgliedschaft ist gesperrt. Wende dich an den Club.",
  "err.bloqueo.pendiente":
    "Deine Aufnahme ist noch nicht bestätigt. Komm im Club vorbei, um sie abzuschließen.",
  "err.bloqueo.cuotaCaducada":
    "Deine Mitgliedschaft ist abgelaufen. Komm im Club vorbei, um sie zu verlängern.",
  "err.bloqueo.cuotaVencida": "Deine Mitgliedschaft ist abgelaufen. Verlängere sie im Club.",
  "servidor.El socio está dado de baja": "Das Mitglied ist ausgetreten",
  "servidor.El socio está suspendido": "Das Mitglied ist gesperrt",
  "servidor.El alta del socio está pendiente de validar": "Die Aufnahme des Mitglieds ist noch nicht bestätigt",
  "servidor.La cuota del socio está caducada": "Die Mitgliedschaft ist abgelaufen",
  "servidor.La cuota del socio ha caducado: hay que renovarla":
    "Die Mitgliedschaft ist abgelaufen: Sie muss verlängert werden",

  "web.entrar": "Anmelden",
  "web.frase":
    "asocis ist das Programm zum Führen einer Anbauvereinigung: Mitglieder, Theke, Lager nach Chargen, Kasse und Mitgliederbereich.",
  "web.fraseSegunda":
    "Unten siehst du die Theke, in Betrieb mit erfundenen Daten. Wähl ein Mitglied, tipp auf Produkte, überschreite sein Limit, kassiere.",
  "web.altasUnaAUna":
    "Wir nehmen die Clubs einzeln auf: Wir geben dir einen Code, und damit richtest du deinen Club in einer Minute ein.",
  "web.yaTienesUno": "Hast du schon einen?",
  "web.pedirPrueba": "Testzugang anfragen",
  "web.pedirAcceso": "Zugang anfragen",
  "web.probarGratis": "{dias} gratis testen",
  "web.crearClub": "Club erstellen",
  "web.pieDemo":
    "Mit deinen Daten macht es dasselbe. Was hier nicht hineinpasst: die Suche nach Name, Nummer oder Ausweis; der QR-Scanner für den Mitgliedsausweis; die Kategorien des Sortiments; die Ermäßigungen von Hand; und der Rest des Menüs.",

  "web.detras": "Was hinter der Theke steckt",
  "web.detras.socios": "Mitglieder",
  "web.detras.socios.texto":
    "Aufnahme mit Ausweis, Foto, Bürge, angegebenem Eigenbedarf und Einwilligung mit Datum. Mitgliedsarten mit ihrem Mitgliedsbeitrag, ihrer Ermäßigung und ihren Limits. Das Mitgliederverzeichnis, das der Verein führen muss, druckfertig. Und «CSV importieren», um sie aus deinem alten Programm zu übernehmen.",
  "web.detras.limites": "Limits",
  "web.detras.limites.texto":
    "Jedes Mitglied hat ein Tageslimit und ein Monatslimit. Die Theke vergleicht die Bestellung mit der schon bezogenen Menge; wird eines überschritten, muss jemand freigeben, und es wird festgehalten, wer das war. An ein Mitglied mit abgelaufener Mitgliedschaft wird erst nach der Verlängerung abgegeben.",
  "web.detras.inventario": "Lager nach Chargen",
  "web.detras.inventario.texto":
    "Zugänge laufen über Chargen, mit Lieferant, Einkaufspreis und Mindesthaltbarkeitsdatum. Die Theke bucht von der ältesten ab, jeder Schwund hat einen Grund, und die Inventur vergleicht das Gezählte mit dem, was da sein müsste. Bei jedem abgegebenen Gramm ist bekannt, aus welcher Charge es kam.",
  "web.detras.caja": "Kasse",
  "web.detras.caja.texto":
    "Die Schicht beginnt mit einem Anfangsbestand, sammelt Abgaben, Tresen und Barausgaben, und beim Kassenabschluss wird gezählt: Das Programm sagt, was da sein müsste, und die Differenz. Ausgaben per Lastschrift berühren die Kasse nicht.",
  "web.detras.cartera": "Guthabenkonto",
  "web.detras.cartera.texto":
    "Das Prepaid-Konto des Mitglieds: Aufladungen, Abbuchungen, Erstattungen. An der Theke wird mit einem Tippen vom Guthabenkonto abgebucht, und wenn es nicht reicht, sagt das Programm Bescheid.",
  "web.detras.barra": "Tresen",
  "web.detras.barra.texto":
    "Kaffee, Getränke und Snacks mit Getränkekarte und schnellem Kassieren. Alles geht in dieselbe Kasse, aber der Kassensturz trennt Tresen und Abgabe.",
  "web.detras.portal": "Mitgliederbereich",
  "web.detras.portal.texto":
    "Auf dem Handy, wie eine App: der Mitgliedsausweis mit QR-Code zum Ausweisen an der Theke, die bezogene Menge gegenüber den Limits, das Guthabenkonto, das Sortiment mit den Pauschalen, die Neuigkeiten des Clubs und Vorbestellungen zum Abholen. Auf {idiomas}.",
  "web.detras.cuotas": "Mitgliedsbeiträge und Verlängerungen",
  "web.detras.cuotas.texto":
    "Kassieren, Fälligkeiten und eine Erinnerung per E-Mail, bevor die Mitgliedschaft abläuft. Spenden laufen getrennt, damit sie bei niemandem das Datum verschieben.",
  "web.detras.gastos": "Ausgaben und Einkäufe",
  "web.detras.gastos.texto":
    "Was dem Lieferanten geschuldet wird und was bezahlt wurde, mit Kategorie, auf demselben Bildschirm. Export für die Steuerkanzlei.",
  "web.detras.acceso": "Einlasskontrolle und Kapazität",
  "web.detras.acceso.texto":
    "Wer gerade drin ist und wie viele heute da waren. Mit einer Kapazitätsgrenze meldet sich das Programm, wenn es voll wird: Die Tür schließt es nicht.",
  "web.detras.informes": "Auswertungen",
  "web.detras.informes.texto":
    "Woher das Geld kommt, pro Tag oder pro Monat, getrennt nach Abgabe, Tresen und Mitgliedsbeiträgen. Ranking der Produkte und der Mitglieder.",
  "web.detras.carta": "Anzeigetafel für den Bildschirm im Club",
  "web.detras.carta.texto":
    "Eine Seite im Vollbild mit dem, was es heute gibt, und der Pauschale dazu. Sie läuft auch bei einem Netzausfall weiter.",

  "web.precio": "Preis",
  "web.precio.texto":
    "Er richtet sich nach der Größe, und es zählen die <b>aktiven</b> Mitglieder: Austritte aus früheren Jahren erhöhen den Preis nicht. Alle Funktionen und das ganze Team sind in jeder Stufe dabei.",
  "web.precio.sociosActivos": "Aktive Mitglieder",
  "web.precio.alMes": "Pro Monat",
  "web.precio.hablamos": "Auf Anfrage",
  "web.precio.consultanos": "Frag uns",
  "web.tramo.hasta": "Bis {hasta} Mitglieder",
  "web.tramo.entre": "Von {desde} bis {hasta} Mitglieder",
  "web.tramo.mas": "Mehr als {desde} Mitglieder",
  "web.precio.prueba": "{dias} zum Testen, um es mit deinen echten Daten zu sehen.",
  "web.precio.condiciones":
    "Keine Mindestlaufzeit: Wenn du aufhörst, nimmst du deine Daten mit, und du kannst den ganzen Club jederzeit als Datei herunterladen, auch an dem Tag, an dem du gehst. Wächst der Club und wechselt die Stufe, sagen wir vorher Bescheid; blockiert wird nie etwas. Aktualisierungen sind inbegriffen.",

  "web.datos": "Zu den Daten",
  "web.datos.texto":
    "Ein Club verarbeitet Ausweisdokumente, Fotos und die bezogenen Mengen seiner Mitglieder: personenbezogene Daten echter Menschen. Jeder Club ist von den anderen getrennt, Passwörter werden verschlüsselt gespeichert, und alles, was getan wird, landet in einem Aktivitätsprotokoll mit Wer und Wann. Von jedem Club wird jede Nacht eine Datensicherung gemacht, und der Club kann sie selbst herunterladen. Das Tablet an der Theke sperrt sich von selbst, wenn es niemand anfasst.",
  "web.datos.nota":
    "Das Programm gibt dir die Werkzeuge; den Auftragsverarbeitungsvertrag mit deinen Mitgliedern und die Aufbewahrungsfristen legst du selbst fest, wie bei jedem anderen Anbieter.",
  "web.empezar": "So fängst du an",
  "web.empezar.nosEscribes": "Du schreibst uns",
  "web.empezar.conCodigo":
    "und wir antworten dir mit einem Aufnahmecode. Das läuft absichtlich einzeln: Jeder Club fängt mit jemandem auf der anderen Seite an.",
  "web.empezar.creasClub": "Du erstellst deinen Club",
  "web.empezar.sinCodigo": "mit dem Namen, den Daten des Vereins und deinem Konto als Vorstand. Eine Minute.",
  "web.empezar.despues":
    "Danach legst du deine Mitgliedsarten fest, den Mitgliedsbeitrag, die Limits und das Sortiment —was du nicht festlegst, hat ab Werk einen vernünftigen Wert—, und deine Mitglieder holst du mit «CSV importieren» herein, das das Verzeichnis deines alten Programms liest. Am selben Tag steht die Theke.",
  "web.pie": "asocis · Verwaltung von Anbauvereinigungen",
  "web.pie.avisoLegal": "Impressum",
  "web.pie.privacidad": "Datenschutz",

  "web.demoEnCastellano":
    "Diese Beispiel-Theke gibt es nur auf Spanisch; das echte Programm und den Mitgliederbereich gibt es auf {idiomas}.",
  "prueba.titulo": "Testzugang anfragen",
  "prueba.intro":
    "Wir nehmen die Clubs einzeln auf: Wir antworten dir mit einem Code, und damit richtest du deinen Club in einer Minute ein. Sag uns, wie viele Mitglieder ihr seid, dann sagen wir dir gleich, was ihr zahlt.",
  "prueba.nombreClub": "Name des Vereins",
  "prueba.ciudad": "Stadt",
  "prueba.socios": "Mitglieder, ungefähr",
  "prueba.sociosAyuda": "Optional. Danach richtet sich der Preis.",
  "prueba.tuNombre": "Dein Name",
  "prueba.tuEmail": "Deine E-Mail",
  "prueba.tuEmailAyuda": "Dorthin schicken wir dir den Code.",
  "prueba.telefono": "Telefon",
  "prueba.telefonoAyuda": "Optional, falls ein Anruf einfacher ist.",
  "prueba.mensaje": "Sollten wir etwas wissen?",
  "prueba.mensajeAyuda": "Optional. Wie ihr es jetzt macht, was euch fehlt, wann ihr starten wollt.",
  "prueba.privacidad1": "Ich habe die",
  "prueba.privacidad2": "Datenschutzerklärung",
  "prueba.privacidad3": "gelesen und bin damit einverstanden, dass diese Daten zur Beantwortung genutzt werden.",
  "prueba.enviar": "Testzugang anfordern",
  "prueba.fallo": "Die Anfrage konnte nicht gesendet werden",
  "prueba.recibido": "Eingegangen.",
  "prueba.recibidoTexto1": "Wir schreiben dir an",
  "prueba.recibidoTexto2": "mit dem Code für die Einrichtung von",
  "prueba.recibidoTexto3":
    ", normalerweise innerhalb eines Werktags. Wenn du nichts siehst, schau im Spam-Ordner nach.",
  "prueba.volverWeb": "Zurück zur Website",

  "g.cargando": "Lädt...",
  "g.cancelar": "Abbrechen",
  "g.cerrar": "Schließen",
  "g.guardar": "Speichern",
  "g.anterior": "Zurück",
  "g.siguiente": "Weiter",
  "g.pagina": "Seite {pagina} von {paginas}",
  "g.estado.ACTIVO": "Aktiv",
  "g.estado.PENDIENTE": "Ausstehend",
  "g.estado.CADUCADO": "Abgelaufen",
  "g.estado.SUSPENDIDO": "Gesperrt",
  "g.estado.BAJA": "Ausgetreten",

  "m.titulo": "Theke",
  "m.descripcion": "Abgabe an ein Mitglied erfassen",
  "m.dudaDeGuardado1": "Schau unter",
  "m.dudaDeGuardado2": "nach, ob die Abgabe erfasst wurde. Wenn sie da ist, nicht wiederholen.",
  "m.dispensaciones": "Abgaben",
  "m.reservas": "Abzuholende Vorbestellungen",
  "m.socio": "Mitglied",
  "m.pedido": "Bestellung",
  "m.total": "Gesamt",
  "m.reservaNumero": "Vorbestellung {numero}",
  "m.faltaGenero": "Ware fehlt",
  "m.cancelarReserva": "Stornieren",
  "m.can.titulo": "Vorbestellung #{numero} stornieren",
  "m.can.quePasa":
    "Das Mitglied sieht die Vorbestellung mit deinem Grund als storniert und kann wieder bestellen. Hat es den Mitgliederbereich auf dem Handy, bekommt es eine Benachrichtigung.",
  "m.can.motivo": "Grund (das Mitglied liest ihn)",
  "m.can.confirmar": "Vorbestellung stornieren",
  "m.can.fallo": "Die Vorbestellung konnte nicht storniert werden",
  "m.can.hecho": "Vorbestellung storniert",
  "m.atender": "Abgeben",
  "m.aQuien": "An wen wird abgegeben?",
  "m.comoBuscar": "Gib mindestens zwei Buchstaben des Namens, die Mitgliedsnummer oder die Ausweisnummer ein.",
  "m.todo": "Alle",
  "m.sinProductos": "In dieser Kategorie sind keine Produkte verfügbar.",
  "m.reservado": "{cantidad} vorbestellt",
  "m.sinStock": "Kein Bestand",
  "m.cambiar": "Ändern",
  "m.hoy": "Heute",
  "m.esteMes": "Diesen Monat",
  "m.cartera": "Guthabenkonto",
  "m.ingresar": "+ Einzahlen",
  "m.ingresarTitulo": "Geld auf das Guthabenkonto einzahlen",
  "m.cuotaVencioHace": "Die Mitgliedschaft ist schon {dias} abgelaufen.",
  "m.cuotaVenceHoy": "Die Mitgliedschaft läuft heute ab.",
  "m.cuotaVenceEn": "Die Mitgliedschaft ist noch {dias} gültig.",
  "m.cobrarAhora": "Jetzt kassieren",
  "m.entrega": "Abgabe",
  "m.tocaProducto": "Tippe ein Produkt an, um es hinzuzufügen.",
  "m.quitar": "Entfernen",
  "m.ahorro": "Ersparnis {importe}",
  "m.descuentoAMano": "Ermäßigung von Hand −{importe}",
  "m.descuento": "Ermäßigung",
  "m.quitarDescuento": "Ermäßigung entfernen",
  "m.hacerDescuento": "Ermäßigung geben",
  "m.superaLimiteCorto": "Überschreitet das verfügbare Limit ({disponible}).",
  "m.registrando": "Wird erfasst...",
  "m.registrar": "Abgabe erfassen · {total}",
  "m.irACobrar": "Zum Kassieren",
  "m.falloRegistrar": "Die Abgabe konnte nicht erfasst werden",
  "m.superaLimite": "Überschreitet das verfügbare Limit: möglich sind {disponible}, gewünscht sind {pedido}",
  "m.soloPropietario": "Nur die Leitung oder höher darf eine Überschreitung des Limits freigeben",

  "m.sinFichar.titulo": "Einlass nicht erfasst",
  "m.sinFichar.texto":
    "ist nicht als anwesend erfasst. Du kannst den Einlass jetzt erfassen und mit der Abgabe weitermachen.",
  "m.sinFichar.nota":
    "Wenn du ohne Einlass weitermachst, wird die Abgabe trotzdem erfasst, aber das Mitglied zählt nicht zur Belegung und steht nicht im Einlassbuch des Tages.",
  "m.sinFichar.seguir": "Ohne Einlass weiter",
  "m.sinFichar.fichar": "Einlass erfassen und weiter",
  "m.sinFichar.fichando": "Einlass wird erfasst...",
  "m.sinFichar.fallo": "Der Einlass konnte nicht erfasst werden",
  "m.limite.titulo": "Limit überschritten",
  "m.limite.autorizar": "Freigeben und erfassen",
  "m.limite.nota":
    "Nur die Leitung oder höher darf das freigeben. Die Freigabe wird mit deinem Namen im Protokoll festgehalten.",
  "m.venta.enCola": "Abgabe auf diesem Tablet gespeichert",
  "m.venta.registrada": "Abgabe #{numero} erfasst",
  "m.venta.quedan": "Es bleiben {importe} auf dem Guthabenkonto",

  "s.titulo": "Mitglieder",
  "s.enElRegistro": "{socios} im Verzeichnis",
  "s.exportar": "CSV exportieren",
  "s.libro": "Mitgliederverzeichnis",
  "s.importar": "CSV importieren",
  "s.carnets": "Mitgliedsausweise",
  "s.nuevo": "+ Neues Mitglied",
  "s.falloExportar": "Konnte nicht exportiert werden",
  "s.buscar": "Nach Name, Nummer oder Ausweis suchen...",
  "s.todosLosEstados": "Alle Status",
  "s.cualquierTipo": "Alle Mitgliedsarten",
  "s.hanVenidoDesde": "Besuch seit",
  "s.sinCoincidencias": "Keine Mitglieder passen zur Suche.",
  "s.sinSocios": "Noch keine Mitglieder.",
  "s.darDeAlta": "Das erste Mitglied aufnehmen",
  "s.oImportar": "die vorhandenen importieren",
  "s.numero": "Nr.",
  "s.socio": "Mitglied",
  "s.documento": "Ausweis",
  "s.estado": "Status",
  "s.cuotaHasta": "Mitgliedschaft bis",
  "s.ultimaVisita": "Letzter Besuch",
  "s.aportado": "Beigetragen",
  "s.cartera": "Guthabenkonto",
  "s.anios": "{anios} Jahre",
  "s.sinTelefono": "kein Telefon",
  "s.queda": "noch {dias}",
  "s.quedan": "noch {dias}",
  "s.nunca": "Nie",
  "s.hoy": "heute",
  "s.ayer": "gestern",
  "s.haceDias": "vor {dias} Tagen",
  "s.haceUnMes": "vor einem Monat",
  "s.haceMeses": "vor {meses} Monaten",
  "s.haceUnAnio": "vor einem Jahr",
  "s.haceAnios": "vor {anios} Jahren",

  "b.marcador": "Mitglied nach Name, Nummer oder DNI suchen...",
  "b.escanear": "Mitgliedsausweis scannen",
  "b.sinCoincidencias": "Kein Mitglied passt zu „{texto}“",
  "b.codigoDesconocido": "Dieser Code gehört zu keinem Mitglied dieses Clubs.",
  "b.falloCodigo": "Der Code konnte nicht geprüft werden. Versuch es noch einmal.",
  "b.escanearBoton": "Scannen",
  "b.qr.sinCamara": "Dieser Browser gibt keinen Zugriff auf die Kamera. Gib die Mitgliedsnummer von Hand ein.",
  "b.qr.sinPermiso":
    "Du hast den Zugriff auf die Kamera nicht erlaubt. Du kannst ihn über das Schloss in der Adressleiste erteilen.",
  "b.qr.sinDispositivo": "Auf diesem Gerät wurde keine Kamera gefunden.",
  "b.qr.falloCamara": "Die Kamera konnte nicht geöffnet werden. Gib die Mitgliedsnummer von Hand ein.",
  "b.qr.apunta":
    "Richte die Kamera auf den Code des Mitglieds. Sobald sie ihn liest, wird das Mitglied von selbst erkannt.",
  "m.productos": "{n} Produkte",
  "m.unProducto": "1 Produkt",

  "c.titulo": "Kasse",
  "c.descripcion": "Kassenschichten und Kassensturz",
  "c.entradaSalida": "Einlage / Entnahme",
  "c.cerrarCaja": "Kasse abschließen",
  "c.abrirCaja": "Kasse öffnen",
  "c.sinCaja": "Du hast keine Kasse offen. Solange sie zu bleibt, landen Bareinnahmen in keinem Kassensturz.",
  "c.otraAbierta": "Im Club ist eine andere Kasse offen, und was du kassierst, läuft nicht darüber.",
  "c.otrasAbiertas": "Im Club sind {n} andere Kassen offen, und was du kassierst, läuft nicht darüber.",
  "c.fondoInicial": "Anfangsbestand",
  "c.abiertaALas": "Geöffnet um {hora}",
  "c.dispensaciones": "Abgaben",
  "c.barra": "Tresen",
  "c.cuotasYRecargas": "Mitgliedsbeiträge und Aufladungen",
  "c.gastos": "Ausgaben",
  "c.deberiaHaber": "Sollbestand",
  "c.formula": "Anfangsbestand + Einlagen − Entnahmen",
  "c.movimientos": "Bewegungen der Schicht",
  "c.sinMovimientos": "In dieser Schicht gibt es noch keine Bewegungen.",
  "c.hora": "Uhrzeit",
  "c.tipo": "Art",
  "c.concepto": "Zweck",
  "c.usuario": "Benutzer",
  "c.importe": "Betrag",
  "c.historial": "Schichtverlauf",

  "c.fa.titulo": "Bargeld außerhalb jeder Abrechnung",
  "c.fa.explicacion":
    "{cuantos} Mal wurde ohne offene Kasse bar kassiert, insgesamt {importe}: Dieses Geld liegt in der Lade und taucht in keiner Schichtabrechnung auf. Das passiert, wenn bei geschlossener Kasse kassiert wird, und bei Abgaben ohne Verbindung, die erst hochgeladen werden, wenn die Schicht der Person schon vorbei ist.",
  "c.fa.explicacionUno":
    "Eine Barzahlung von {importe} wurde ohne offene Kasse angenommen: Dieses Geld liegt in der Lade und taucht in keiner Schichtabrechnung auf. Das passiert, wenn bei geschlossener Kasse kassiert wird, und bei Abgaben ohne Verbindung, die erst hochgeladen werden, wenn die Schicht der Person schon vorbei ist.",
  "c.fa.cuando": "Wann",
  "c.fa.que": "Was",
  "c.fa.importe": "Betrag",
  "c.fa.hayMas": "Es werden nur die 100 neuesten angezeigt.",
  "c.fa.tipo.DISPENSACION": "Abgabe",
  "c.fa.tipo.BARRA": "Theke",
  "c.fa.tipo.CUOTA": "Beitrag",
  "c.fa.tipo.DONACION": "Spende",
  "c.fa.tipo.RECARGA": "Aufladung",
  "c.fa.tipo.GASTO": "Ausgabe",
  "c.sinTurnos": "Es wurde noch keine Schicht abgeschlossen.",
  "c.apertura": "Öffnung",
  "c.cierre": "Abschluss",
  "c.responsable": "Verantwortlich",
  "c.teorico": "Soll",
  "c.contado": "Gezählt",
  "c.diferencia": "Differenz",
  "c.abierta": "Offen",
  "c.cuadra": "Stimmt",
  "c.abrir.titulo": "Kasse öffnen",
  "c.abrir.fondo": "Anfangsbestand der Kasse (Credits)",
  "c.abrir.fondoAyuda": "Geld, mit dem die Schicht startet.",
  "c.abrir.notas": "Notizen",
  "c.abrir.notasEjemplo": "Spätschicht...",
  "c.abrir.boton": "Öffnen",
  "c.abrir.fallo": "Die Kasse konnte nicht geöffnet werden",
  "c.cerrar.titulo": "Kasse abschließen",
  "c.cerrar.segunSistema": "Sollbestand laut System",
  "c.cerrar.contado": "Gezähltes Geld in der Kassenlade (Credits)",
  "c.cerrar.descuadre": "Differenz von",
  "c.cerrar.sobra": "(zu viel Geld).",
  "c.cerrar.falta": "(zu wenig Geld).",
  "c.cerrar.cuadra": "Die Kasse stimmt genau.",
  "c.cerrar.observaciones": "Bemerkungen zum Abschluss",
  "c.cerrar.boton": "Schicht abschließen",
  "c.cerrar.fallo": "Die Kasse konnte nicht abgeschlossen werden",
  "c.mov.titulo": "Kassenbewegung",
  "c.mov.tipo": "Art",
  "c.mov.salida": "Barentnahme",
  "c.mov.entrada": "Bareinlage",
  "c.mov.nota1": "Für eine Rechnung oder einen Einkauf nutze",
  "c.mov.gastos": "Ausgaben",
  "c.mov.nota2": ": dann geht das Geld nicht nur aus der Kasse, sondern ist auch eingeordnet.",
  "c.mov.importe": "Betrag (Credits)",
  "c.mov.concepto": "Zweck",
  "c.mov.conceptoEjemplo": "Materialeinkauf...",
  "c.mov.boton": "Erfassen",
  "c.mov.fallo": "Die Bewegung konnte nicht erfasst werden",
  "movimiento.ENTRADA": "Zugang",
  "movimiento.SALIDA": "Abgang",
  "movimiento.DISPENSACION": "Abgabe",
  "movimiento.MERMA": "Schwund",
  "movimiento.GASTO": "Ausgabe",

  "i.titulo": "Lager",
  "i.descripcion": "Zugänge, Schwund und Inventuren des Bestands",
  "i.almacen": "Bestand",
  "i.movimientos": "Bewegungen",
  "i.exportar": "CSV exportieren",
  "i.falloExportar": "Konnte nicht exportiert werden",
  "i.enElMostrador": "An der Theke",
  "i.valor": "Lagerwert",
  "i.valorPie": "Nach der Pauschale aus dem Sortiment",
  "i.coste": "Einkaufspreis des Bestands",
  "i.costePie": "Was dafür bezahlt wurde",
  "i.avisos": "Hinweise",
  "i.avisosPie": "{bajos} unter Mindestbestand · {caducan} laufen bald ab",
  "i.porCaducar": "Chargen, die bald ablaufen:",
  "i.buscar": "Produkt oder Kategorie suchen...",
  "i.nProductos": "{n} Produkte",
  "i.unProducto": "1 Produkt",
  "i.sinProductos": "Keine Produkte. Lege sie zuerst im Sortiment an.",
  "i.producto": "Produkt",
  "i.categoria": "Kategorie",
  "i.unidad": "Einheit",
  "i.enVenta": "Theke",
  "i.guardado": "Eingelagert",
  "i.total": "Gesamt",
  "i.minimo": "Mindestbestand",
  "i.lotes": "Chargen",
  "i.caduca": "MHD",
  "i.valorColumna": "Wert",
  "i.costeColumna": "Einkaufspreis",
  "i.bajoMinimo": "unter Mindestbestand",
  "i.inactivo": "Inaktiv",
  "i.entrada": "Zugang",
  "i.merma": "Schwund",
  "i.ajuste": "Bestandskorrektur",
  "i.ultimos": "Letzte Bewegungen",
  "i.sinRegistros": "Keine Bewegungen erfasst.",
  "i.fecha": "Datum",
  "i.tipo": "Art",
  "i.cantidad": "Menge",
  "i.op.entrada": "Zugang von {producto}",
  "i.op.merma": "Schwund bei {producto}",
  "i.op.ajuste": "Bestandskorrektur bei {producto}",
  "i.op.stockActual": "Aktueller Bestand:",
  "i.op.cantidad": "Menge",
  "i.op.stockContado": "Gezählter Bestand",
  "i.op.ajusteAyuda": "Die Differenz zum Systembestand wird erfasst.",
  "i.op.codigoLote": "Chargennummer",
  "i.op.codigoAyuda": "Wird automatisch erzeugt, wenn du das Feld leer lässt.",
  "i.op.costeTotal": "Einkaufspreis gesamt (Credits)",
  "i.op.proveedor": "Herkunft / Lieferant",
  "i.op.caducidad": "Mindesthaltbarkeitsdatum",
  "i.op.motivo": "Grund",
  "i.op.motivoAyuda": "Bleibt im Verlauf stehen.",
  "i.op.registrar": "Erfassen",
  "i.op.fallo": "Der Vorgang konnte nicht erfasst werden",
  "i.gd.titulo": "Lager · {producto}",
  "i.gd.enVenta": "An der Theke:",
  "i.gd.guardado": "Im Lager:",
  "i.gd.queSeHace": "Was passieren soll",
  "i.gd.aVenta": "Vom Lager an die Theke holen",
  "i.gd.aGuardado": "Von der Theke ins Lager zurücknehmen",
  "i.gd.comoMucho": "Höchstens {cantidad}.",
  "i.gd.motivoAyuda": "Optional. Bleibt im Bewegungsverlauf stehen.",
  "i.gd.moviendo": "Wird verschoben...",
  "i.gd.sacar": "An die Theke holen",
  "i.gd.fallo": "Konnte nicht verschoben werden",
  "g.guardando": "Wird gespeichert...",
  "i.guardadosPie": "{cantidad} im Lager",

  "ba.titulo": "Tresen",
  "ba.descripcion": "Kaffee, Getränke und alles, was keine Abgabe ist",
  "ba.carta": "Getränkekarte",
  "ba.vacia": "Die Getränkekarte ist leer.",
  "ba.vaciaAdmin": " Trag unter «Getränkekarte» ein, was ihr verkauft.",
  "ba.vaciaSocio": " Frag einen Admin, ob er sie einrichtet.",
  "ba.sinExistencias": "Kein Bestand",
  "ba.agotado": "Ausverkauft",
  "ba.quedan": "Noch {n}",
  "ba.cobro": "Kassieren",
  "ba.tocaProducto": "Tipp ein Produkt an, um zu starten.",
  "ba.cadaUno": "{importe} / Stück",
  "ba.vaciar": "Leeren",
  "ba.cobrando": "Wird kassiert...",
  "ba.cobrar": "{total} kassieren",
  "ba.faltaSocio": "Zum Abbuchen vom Guthabenkonto musst du ein Mitglied auswählen.",
  "ba.hoy": "Tresen heute",
  "ba.unCobro": "1 Zahlung",
  "ba.cobros": "{n} Zahlungen",
  "ba.ultimos": "Letzte Zahlungen",
  "ba.sinCobros": "Am Tresen wurde heute noch nichts kassiert.",
  "ba.anulada": "Storniert",
  "ba.falloCobrar": "Konnte nicht kassiert werden",
  "ba.cobrado": "{importe} kassiert · Tresenbeleg {numero}",
  "ba.c.nombre": "Name",
  "ba.c.nombreEjemplo": "Milchkaffee",
  "ba.c.grupo": "Gruppe",
  "ba.c.grupoAyuda": "Damit sie auf dem Bildschirm zusammen stehen.",
  "ba.c.grupoPorDefecto": "Getränke",
  "ba.c.precio": "Preis (Credits)",
  "ba.c.existencias": "Bestand",
  "ba.c.existenciasAyuda": "Nur, wenn du mitzählen willst.",
  "ba.c.llevarCuenta": "Bestand mitzählen",
  "ba.c.llevarCuentaNota": "Kaffee aus dem Automaten muss man nicht zählen, eine Kiste Dosen schon.",
  "ba.c.anadir": "Zur Getränkekarte hinzufügen",
  "ba.c.producto": "Produkt",
  "ba.c.precioColumna": "Preis",
  "ba.c.quedan": "noch {n}",
  "ba.c.quitar": "Entfernen",
  "ba.c.reponer": "Auffüllen",
  "ba.c.fallo": "Konnte nicht gespeichert werden",

  "d.titulo": "Abgaben und Tresen",
  "d.descripcion": "Alles, was rausgegangen ist, Beleg für Beleg",
  "d.a": "bis",
  "d.exportar": "CSV exportieren",
  "d.falloExportar": "Konnte nicht exportiert werden",
  "d.dispensario": "Abgabestelle",
  "d.barra": "Tresen",
  "d.buscar": "Mitglied, Produkt oder Belegnummer suchen",
  "d.atendioCualquiera": "Egal wer bedient hat",
  "d.baja": " (ausgetreten)",
  "d.todosLosPuestos": "Alle Kassenplätze",
  "d.todos": "Alle",
  "d.soloValidos": "Nur gültige",
  "d.soloAnulados": "Nur stornierte",
  "d.quitarFiltros": "Filter zurücksetzen",
  "d.entregas": "Abgaben",
  "d.cobros": "Zahlungen",
  "d.unAnulado": "1 storniert",
  "d.anulados": "{n} storniert",
  "d.cantidad": "Menge",
  "d.aportaciones": "Pauschalen",
  "d.deDescuento": "{importe} Ermäßigung",
  "d.aMano": "{importe} von Hand",
  "d.sinCoincidencias": "Kein Beleg passt zu deiner Suche.",
  "d.sinDispensaciones": "In diesem Zeitraum gibt es keine Abgaben.",
  "d.sinCobros": "In diesem Zeitraum wurde am Tresen nichts kassiert.",
  "d.numero": "Nr.",
  "d.fecha": "Datum",
  "d.socio": "Mitglied",
  "d.productos": "Produkte",
  "d.articulos": "Positionen",
  "d.descuento": "Ermäßigung",
  "d.importe": "Betrag",
  "d.atendio": "Bedient von",
  "d.laSubio": "Hochgeladen von {nombre}",
  "d.sinSocio": "Ohne Mitglied",
  "d.anulada": "Storniert",
  "d.sinConexion": "Offline",
  "d.sinConexionAyuda": "Ohne Netz erfasst und übertragen, sobald die Verbindung wieder da war",
  "d.descuentoAMano": "von Hand {importe}",
  "d.ticket": "Beleg",
  "d.anular": "Stornieren",
  "d.tope":
    "Zu sehen sind die neuesten Zahlungen des Zeitraums, höchstens {tope}. Grenze den Zeitraum enger ein, um den Rest zu sehen.",
  "d.ticketNumero": "Beleg #{numero}",
  "d.imprimir": "Drucken",
  "d.an.tituloDispensacion": "Abgabe #{numero} stornieren",
  "d.an.tituloVenta": "Verkauf #{numero} stornieren",
  "d.an.dispensario": "{cantidad} gehen zurück in den Bestand.",
  "d.an.dispensarioCartera":
    "{cantidad} gehen zurück in den Bestand und {importe} zurück auf das Guthabenkonto des Mitglieds.",
  "d.an.dispensarioCaja":
    "{cantidad} gehen zurück in den Bestand und {importe} werden als Entnahme aus der Kasse erfasst.",
  "d.an.barra": "Die Einheiten gehen zurück in den Tresenbestand.",
  "d.an.barraCartera":
    "Die Einheiten gehen zurück in den Tresenbestand und {importe} zurück auf das Guthabenkonto des Mitglieds.",
  "d.an.barraCaja":
    "Die Einheiten gehen zurück in den Tresenbestand und {importe} werden als Entnahme aus der Kasse erfasst.",
  "d.an.motivo": "Grund für die Stornierung",
  "d.an.anular": "Stornieren",
  "d.an.fallo": "Konnte nicht storniert werden",

  "tk.preparando": "Beleg wird vorbereitet...",
  "tk.ticket": "Beleg #{numero}",
  "tk.socio": "Mitglied #{numero}",
  "tk.atiende": "Bedient von",
  "tk.anulada": "*** STORNIERT ***",
  "tk.unidades": "{cantidad} Stk x {precio}",
  "tk.gramos": "{cantidad} g x {precio}/g",
  "tk.catalogo": "{texto} · Sortiment {importe}",
  "tk.total": "GESAMT",
  "tk.descuentoAplicado": "Ermäßigung angewendet",
  "tk.descuento": "Ermäßigung",
  "tk.descuentoCon": "Ermäßigung {texto}",
  "tk.totalDispensado": "Abgegeben gesamt",
  "tk.formaDePago": "Zahlungsart",
  "tk.saldoRestante": "Restguthaben",
  "tk.documentoInterno": "Internes Dokument des Vereins. Keine Rechnung.",

  "nav.gestionDe": "Vereinsverwaltung",
  "nav.inicio": "Start",
  "nav.mostrador": "Theke",
  "nav.grupoAsociacion": "Verein",
  "nav.donaciones": "Spenden",
  "nav.socios": "Mitglieder",
  "nav.caja": "Kasse",
  "nav.gastos": "Ausgaben und Einkäufe",
  "nav.inventario": "Lager",
  "nav.recuentos": "Inventuren",
  "nav.barra": "Tresen",
  "nav.dispensaciones": "Abgaben",
  "nav.descuentos": "Ermäßigungen",
  "nav.grupoAjustes": "Einstellungen",
  "nav.informes": "Auswertungen",
  "nav.ajustes": "Einstellungen",
  "nav.dias": "Tage",
  "nav.contrato": "Vertrag",
  "nav.accesos": "Einlasskontrolle",
  "nav.renovaciones": "Verlängerungen",
  "nav.cuotas": "Mitgliedsbeiträge",
  "nav.comunidad": "Gemeinschaft",
  "nav.catalogo": "Sortiment",
  "nav.cartas": "Anzeigetafeln",
  "nav.contrasena": "Passwort",
  "rol.PROPIETARIO": "Vorstand",
  "rol.TRABAJADOR": "Teammitglied",
  "nav.pw.titulo": "Mein Passwort ändern",
  "nav.pw.hecho": "Passwort geändert. Nimm es beim nächsten Anmelden.",
  "nav.pw.actual": "Aktuelles Passwort",
  "nav.pw.nueva": "Neues Passwort",
  "nav.pw.minimo": "Mindestens 8 Zeichen.",
  "nav.pw.repetir": "Neues Passwort wiederholen",
  "nav.pw.noCoinciden": "Stimmt nicht überein.",
  "nav.pw.cambiar": "Ändern",
  "nav.pw.fallo": "Das Passwort konnte nicht geändert werden",

  "p.buenosDias": "Guten Morgen",
  "p.buenasTardes": "Guten Tag",
  "p.buenasNoches": "Guten Abend",
  "p.saludo": "{saludo}, {nombre}",
  "p.descripcion": "Überblick über die Aktivität im Club",
  "p.nuevaDispensacion": "Neue Abgabe",
  "p.sinCaja": "Es ist keine Kasse offen. Barzahlungen tauchen im Kassensturz nicht auf.",
  "p.abrirCaja": "Kasse öffnen",
  "p.unaSolicitud": "1 Aufnahmeantrag wartet auf Antwort.",
  "p.solicitudes": "{n} Aufnahmeanträge warten auf Antwort.",
  "p.verSolicitudes": "Anträge ansehen",
  "p.unaCuotaVencida": "1 Mitglied mit abgelaufener Mitgliedschaft.",
  "p.cuotasVencidas": "{n} Mitglieder mit abgelaufener Mitgliedschaft.",
  "p.unaPorVencer": "1 Mitgliedschaft läuft in den nächsten 30 Tagen ab.",
  "p.porVencer": "{n} Mitgliedschaften laufen in den nächsten 30 Tagen ab.",
  "p.verRenovaciones": "Verlängerungen ansehen",
  "p.pocoStockDe": "Der Bestand an {producto} wird knapp.",
  "p.bajoMinimo": "{n} Produkte liegen unter dem Mindestbestand.",
  "p.verInventario": "Lager ansehen",
  "p.dispensadoHoy": "Heute abgegeben",
  "p.unaEntrega": "1 Abgabe",
  "p.entregas": "{n} Abgaben",
  "p.unSocio": "1 Mitglied",
  "p.socios": "{n} Mitglieder",
  "p.entregasASocios": "{entregas} an {socios}",
  "p.aportacionesHoy": "Pauschalen heute",
  "p.cajaAbierta": "Kasse offen",
  "p.sinCajaAbierta": "Keine Kasse offen",
  "p.barraHoy": "Tresen heute",
  "p.sociosActivos": "Aktive Mitglieder",
  "p.enTotal": "{n} insgesamt",
  "p.esteMes": "Diesen Monat",
  "p.enEntregas": "{importe} bei {entregas}",
  "p.masDispensado": "Heute am meisten abgegeben",
  "p.nadaHoy": "Heute ist noch nichts rausgegangen.",
  "p.producto": "Produkt",
  "p.entregasColumna": "Abgaben",
  "p.cantidad": "Menge",
  "p.importe": "Betrag",
  "p.masBarra": "Heute am Tresen am meisten verkauft",
  "p.nadaBarra": "Heute nichts am Tresen.",
  "p.cobrosColumna": "Zahlungen",
  "p.unidades": "Stück",
  "p.ultimas": "Letzte Abgaben",
  "p.sinDispensaciones": "Es sind noch keine Abgaben erfasst.",
  "p.socio": "Mitglied",
  "p.fecha": "Datum",
  "p.anulada": "Storniert",
  "p.primerosPasos": "Erste Schritte",
  "p.recienCreado": "Der Club ist gerade erst angelegt. Das solltest du vorbereiten, bevor die Theke aufmacht:",
  "p.paso.ajustes": "Geh die Einstellungen durch",
  "p.paso.ajustesResto": ": Tageslimit und Monatslimit pro Mitglied, Jahresbeitrag und Vereinsdaten.",
  "p.paso.catalogo": "Leg die Sorten an",
  "p.paso.catalogoResto": " mit ihrer Pauschale pro Gramm. Die Grundkategorien sind schon angelegt.",
  "p.paso.stock": "Trag den Anfangsbestand ein",
  "p.paso.stockResto": " mit einem Zugang pro Charge jeder Sorte.",
  "p.paso.socio": "Nimm das erste Mitglied auf",
  "p.paso.socioResto": " und kassier den Mitgliedsbeitrag.",
  "p.paso.caja": "Öffne die Kasse",
  "p.paso.cajaResto": " zu Beginn der Schicht, damit das Bargeld stimmt.",
  "p.estadoSocios": "Status der Mitglieder",
  "p.stockBajo": "Bestand niedrig",

  "il.buscarSocio": "Mitglied suchen",
  "il.nuevoSocio": "Neues Mitglied",
  "il.dispensar": "Abgeben",
  "il.barra": "Tresen",
  "il.dentroAhora": "Jetzt im Club",
  "il.aforoCompleto": "Club voll",
  "il.hanPasadoHoy": "Heute da gewesen",
  "il.solicitudes": "Aufnahmeanträge",
  "il.esperando": "warten",
  "il.anotarGasto": "Ausgabe erfassen",

  "pp.paraEmpezar": "Für den Anfang",
  "pp.enEsteOrden":
    "In dieser Reihenfolge geht es am schnellsten. Das hier verschwindet von selbst, sobald ihr im Betrieb seid.",
  "pp.hechosDe": "{hechos} von {total}",
  "pp.ir": "Öffnen",
  "pasos.datos.titulo": "Vervollständige die Clubdaten",
  "pasos.datos.detalle": "Name, Steuernummer und Adresse. Sie stehen auf den Belegen und im Mitgliederverzeichnis.",
  "pasos.productos.titulo": "Leg dein Sortiment an",
  "pasos.productos.detalle": "Die Kategorien stehen schon. Trag ein, was ihr abgebt, mit seiner Pauschale.",
  "pasos.stock.titulo": "Trag deinen Bestand ein",
  "pasos.stock.detalle":
    "Ein Zugang pro Charge, mit Lieferant und Einkaufspreis. Daraus entsteht die Rückverfolgbarkeit.",
  "pasos.socios.titulo": "Nimm die Mitglieder auf",
  "pasos.socios.detalle": "Einzeln, oder per CSV-Import aus dem Programm, das ihr vorher hattet.",
  "pasos.equipo.titulo": "Füge dein Team hinzu",
  "pasos.equipo.detalle":
    "Jede Person mit eigenem Konto und eigener Rolle: so steht im Protokoll, wer was gemacht hat.",
  "pasos.caja.titulo": "Öffne die Kasse für heute",
  "pasos.caja.detalle":
    "Mit dem Anfangsbestand. Beim Schließen vergleicht der Kassensturz das Gezählte mit dem, was da sein müsste.",

  "as.soloLectura": "Das Programm ist im Nur-Lese-Modus.",
  "as.llevaSinRegularizar":
    "Das Abo ist schon {dias} offen. Ihr könnt alles ansehen und die Datensicherungen unter Einstellungen herunterladen, aber keine neuen Bewegungen erfassen. Sobald die Zahlung eingeht, ist sofort alles wieder da.",
  "as.vencioAyer": "Das Abo ist gestern abgelaufen.",
  "as.vencioHace": "Das Abo ist schon {dias} abgelaufen.",
  "as.siSigue": "Vorerst ändert sich nichts. Bleibt es weiter offen, geht das Programm in den Nur-Lese-Modus.",
  "as.venceHoy": "Das Abo läuft heute ab{fecha}.",
  "as.venceManana": "Das Abo läuft morgen ab{fecha}.",
  "as.venceEn": "Das Abo ist noch {dias} gültig{fecha}.",
  "as.entreParentesis": " ({fecha})",
  "as.noHayQueHacer": "Hier ist nichts zu tun: Das Datum aktualisiert sich von selbst, sobald die Zahlung eingeht.",

  "bl.explicacion":
    "Der Bildschirm hat sich von selbst gesperrt, weil er nicht benutzt wurde. Gib dein Passwort ein, um da weiterzumachen, wo du aufgehört hast.",
  "bl.tuContrasena": "Dein Passwort",
  "bl.comprobando": "Wird geprüft...",
  "bl.continuar": "Weiter",
  "bl.salirOtraCuenta": "Abmelden und mit anderem Konto anmelden",
  "bl.fallo": "Das Passwort konnte nicht geprüft werden",

  "ec.sinConexion": "Keine Verbindung zum Server.",
  "ec.sinConexionDesde": "Keine Verbindung zum Server seit {hora}.",
  "ec.conPaquete":
    "Die Theke läuft mit dem weiter, was auf diesem Tablet gespeichert ist: Die Abgaben werden hier notiert und gehen von selbst raus, sobald das Netz wieder da ist.",
  "ec.sinPaquete":
    "Auf diesem Tablet ist kein Sortiment gespeichert: Bis das Netz wieder da ist, kann nicht abgegeben werden.",
  "ec.unaPendiente": "1 Abgabe wartet auf den Versand.",
  "ec.pendientes": "{n} Abgaben warten auf den Versand.",
  "ec.unaRechazada": "1 vom Server abgelehnt.",
  "ec.rechazadas": "{n} vom Server abgelehnt.",
  "ec.hayRechazada": "Eine Abgabe hat der Server nicht angenommen: Sieh sie dir an.",
  "ec.hayRechazadas": "{n} Abgaben hat der Server nicht angenommen: Sieh sie dir an.",
  "ec.verCola": "Warteschlange ansehen ({n})",
  "ec.enviando": "Wird gesendet...",
  "ec.enviarAhora": "Jetzt senden",
  "ec.titulo": "Auf diesem Tablet gespeicherte Abgaben",
  "ec.explicacion":
    "Sie wurden ohne Verbindung gemacht und gehen in dieser Reihenfolge von selbst raus, sobald das Netz wieder da ist. Der Server bucht sie mit seinen eigenen Beträgen ab und vermerkt bei der Abgabe als Auffälligkeit, was dabei übergangen wurde (Limit, Bestand, Guthaben).",
  "ec.nadaPorEnviar": "Es ist nichts mehr zu senden.",
  "ec.cuando": "Wann",
  "ec.socio": "Mitglied",
  "ec.que": "Was",
  "ec.importe": "Betrag",
  "ec.estado": "Status",
  "ec.rechazada": "Abgelehnt: {motivo}",
  "ec.reintentar": "Erneut versuchen",
  "ec.descartar": "Verwerfen",
  "ec.confirmarDescartar": "Diese Abgabe verwerfen? Sie wird nirgends erfasst.",
  "ec.pendienteDeEnviar": "Versand ausstehend",
  "ec.unIntento": " (1 Versuch)",
  "ec.intentos": " ({n} Versuche)",

  "gi.titulo": "Woher das Geld kommt",
  "gi.dias7": "7 Tage",
  "gi.dias30": "30 Tage",
  "gi.meses12": "12 Monate",
  "gi.dispensacion": "Abgabe",
  "gi.barra": "Tresen",
  "gi.cuotas": "Mitgliedsbeiträge",
  "gi.sinIngresos": "In diesem Zeitraum sind noch keine Einnahmen erfasst.",

  "tb.dejarRecadoEquipo": "Dem Team eine Notiz hinterlassen",
  "tb.titulo": "Schwarzes Brett",
  "tb.dejarRecado": "Eine Notiz hinterlassen",
  "tb.ejemplo": "Die Ware kommt Donnerstagvormittag...",
  "tb.fijarArriba": "Oben festpinnen",
  "tb.poniendo": "Wird angeheftet...",
  "tb.poner": "Anheften",
  "tb.alguien": "Jemand",
  "tb.quitar": "Vom Brett nehmen",

  "dc.titulo": "Mitgliedsbeitrag von {socio} kassieren",
  "dc.cobrando": "Wird kassiert...",
  "dc.cobrar": "Kassieren",
  "dc.importe": "Betrag (Credits)",
  "dc.periodo": "Zeitraum",
  "dc.unAnio": "1 Jahr",
  "dc.dosAnios": "2 Jahre",
  "dc.tresAnios": "3 Jahre",
  "dc.formaDePago": "Zahlungsart",
  "dc.carteraDelSocio": "Guthabenkonto des Mitglieds",
  "dc.nota":
    "Wenn noch Zeit übrig ist, hängt der neue Zeitraum hinten dran; ist die Mitgliedschaft abgelaufen, zählt er ab heute.",
  "dc.fallo": "Der Mitgliedsbeitrag konnte nicht kassiert werden",

  "dr.titulo": "Auf das Guthabenkonto von {socio} einzahlen",
  "dr.ingresar": "{importe} einzahlen",
  "dr.tieneAhora": "Hat jetzt",
  "dr.leFaltan": "Es fehlen {importe} für das, was gerade bezogen wird.",
  "dr.importe": "Betrag (Credits)",
  "dr.formaDePago": "Zahlungsart",
  "dr.entraEnCaja": "Kommt in die Kasse der Schicht.",
  "dr.noTocaCaja": "Rührt die Kasse nicht an.",
  "dr.seQuedaraCon": "Hat danach",
  "dr.noEsIngreso": "Dieses Geld ist keine Einnahme des Vereins.",
  "dr.esDelSocio": "Es gehört dem Mitglied, bis es ausgegeben ist, und kann zurückverlangt werden.",
  "dr.confirmarTitulo": "Hast du das Geld kassiert?",
  "dr.todaviaNo": "Noch nicht",
  "dr.ingresando": "Wird eingezahlt...",
  "dr.siIngresar": "Ja, einzahlen",
  "dr.vasASumar": "Du buchst {importe} auf das Guthabenkonto von {socio}, damit sind es dann {total}.",
  "dr.confirmoEfectivo": "Ich bestätige, dass ich {importe} in bar kassiert habe",
  "dr.confirmo": "Ich bestätige, dass ich {importe} kassiert habe",
  "dr.siTeEquivocas":
    "Wenn du dich vertust, lässt sich das in der Mitgliedsakte richten: Guthaben zurückzahlen oder korrigieren, beides wird protokolliert. Aber es ist viel einfacher, sich jetzt nicht zu vertun.",
  "dr.fallo": "Es konnte nicht eingezahlt werden",

  "cc.entregado": "Gegeben",
  "cc.aCobrar": "Zu zahlen",
  "cc.cambio": "Rückgeld",
  "cc.faltan": "Es fehlen {importe}",
  "cc.oEscribelo": "Oder tipp es ein",
  "cc.poner": "Übernehmen",
  "cc.empezarDeNuevo": "Von vorn",

  "fp.firmado": "Unterschrieben.",
  "fp.estaBien": "Passt es? Bestätige es.",
  "fp.firmaAqui": "Unterschreib hier mit dem Finger oder der Maus.",
  "fp.repetirTitulo": "Unterschrift wiederholen",
  "fp.repetir": "Wiederholen",
  "fp.confirmar": "Bestätigen",

  "ci.sinCamara": "Dieser Browser gibt keinen Zugriff auf die Kamera. Lad das Bild von der Festplatte hoch.",
  "ci.sinPermiso":
    "Du hast keine Berechtigung für die Kamera erteilt. Du kannst sie über das Schloss in der Adressleiste geben.",
  "ci.sinDispositivo": "Es wurde keine Kamera gefunden. Lad das Bild von der Festplatte hoch.",
  "ci.falloCamara": "Die Kamera konnte nicht geöffnet werden. Lad das Bild von der Festplatte hoch.",
  "ci.obligatoria": "Pflicht",
  "ci.saltada": "Übersprungen",
  "ci.hacerFoto": "Foto machen",
  "ci.repetir": "Wiederholen",
  "ci.camara": "Kamera",
  "ci.subir": "Hochladen",
  "ci.quitar": "Entfernen",

  "cs.titulo": "Mitgliedsvertrag",
  "cs.firmoEl": "Hat Version {numero} am {fecha} unterschrieben.",
  "cs.firmo": "Hat Version {numero} unterschrieben.",
  "cs.sinFirmar":
    "Nicht unterschrieben. Unten steht der heutige (Version {numero}) mit seinen Daten, fertig zum Ausdrucken.",
  "cs.verEImprimir": "Ansehen und drucken",
  "cs.apuntando": "Wird vermerkt...",
  "cs.marcarFirmado": "Als unterschrieben markieren",
  "cs.tambienPortal":
    "Das Mitglied kann ihn auch selbst im Mitgliederbereich annehmen, dann wird es von selbst vermerkt.",
  "cs.verContratoClub": "Vertrag des Clubs ansehen",
  "cs.modalTitulo": "Vertrag · Mitglied Nr. {numero}",
  "cs.noFirmadoAun": "Noch nicht unterschrieben: Das hier ist das Dokument zum Mitnehmen an die Theke.",
  "cs.firmaDelSocio": "Unterschrift des Mitglieds",
  "cs.firmaYSello": "Unterschrift und Stempel des Vereins",
  "cs.fallo": "Die Unterschrift konnte nicht vermerkt werden",

  "sn.titulo": "Neues Mitglied",
  "sn.descripcion": "Gespeichert wird am Ende: bis dahin kannst du hin und her springen",
  "sn.paso.avalista": "Bürge",
  "sn.paso.datos": "Daten",
  "sn.paso.documento": "Ausweis",
  "sn.paso.contrato": "Vertrag",
  "sn.paso.cuota": "Mitgliedsbeitrag",
  "sn.paso.repaso": "Prüfen",
  "sn.falta.nombre": "Trag den Vornamen ein",
  "sn.falta.apellidos": "Trag den Nachnamen ein",
  "sn.falta.nacimiento": "Das Geburtsdatum fehlt",
  "sn.falta.documento": "Die Ausweisnummer fehlt",
  "sn.falta.foto": "Das Foto des Mitglieds fehlt",
  "sn.falta.frente": "Die Vorderseite des Ausweises fehlt",
  "sn.falta.reverso": "Die Rückseite des Ausweises fehlt, oder hak an, dass es keine gibt",
  "sn.quienAvala": "Wer bürgt?",
  "sn.avalistaNota":
    "Viele Satzungen verlangen, dass ein Mitglied für das neue bürgt. Wenn eure das nicht tut, überspring den Schritt.",
  "sn.quitar": "Entfernen",
  "sn.quienEs": "Wer ist das Mitglied",
  "sn.nombre": "Vorname",
  "sn.apellidos": "Nachname",
  "sn.nacimiento": "Geburtsdatum",
  "sn.consumo": "Voraussichtlicher Eigenbedarf (g/Monat)",
  "sn.consumoAyuda": "Vom Mitglied angegeben; steht im Vertrag.",
  "sn.telefono": "Telefon",
  "sn.email": "E-Mail",
  "sn.dondeVive": "Wo wohnt das Mitglied",
  "sn.direccion": "Adresse",
  "sn.ciudad": "Stadt",
  "sn.cp": "Postleitzahl",
  "sn.numeroSocio": "Mitgliedsnummer",
  "sn.numeroAyuda": "Leer: die nächste freie.",
  "sn.idioma": "Sprache",
  "sn.idiomaAyuda": "In der das Mitglied den Mitgliederbereich sieht und die Mails bekommt.",
  "sn.idiomaDelClub": "Die des Clubs",
  "sn.notas": "Interne Notizen",
  "sn.documento": "Ausweisdokument",
  "sn.tipo": "Art",
  "sn.pasaporte": "Reisepass",
  "sn.numero": "Nummer",
  "sn.fotoSocio": "Foto des Mitglieds",
  "sn.fotoSocioAyuda": "Zum Wiedererkennen an der Theke",
  "sn.docFrente": "Ausweis, Vorderseite",
  "sn.docFrenteAyuda": "Die Seite mit dem Foto",
  "sn.docReverso": "Ausweis, Rückseite",
  "sn.noLoTiene": "Nicht vorhanden",
  "sn.docReversoAyuda": "Die Seite hinten",
  "sn.sinReverso": "Keine Rückseite",
  "sn.fotosHacenFalta":
    "Die Fotos braucht ihr für die Aufnahme: nur so lässt sich später prüfen, dass die Person auch die war, für die sie sich ausgegeben hat. Ohne Kamera kann man sie von der Festplatte hochladen.",
  "sn.loQueFirma": "Was unterschrieben wird",
  "sn.firma": "Unterschrift",
  "sn.rgpd": "Hat auch die DSGVO-Einwilligung zur Datenverarbeitung unterschrieben",
  "sn.sinFirmaSigue":
    "Ohne Unterschrift läuft die Aufnahme trotzdem durch, aber beim Mitglied bleibt die Unterschrift ausstehend, und es kann sie im Mitgliederbereich nachholen.",
  "sn.cuota": "Mitgliedsbeitrag",
  "sn.cuotaNota":
    "Jede Mitgliedsart hat ihren Mitgliedsbeitrag, ihre Ermäßigung und ihre Limits. Geändert wird das in den Einstellungen.",
  "sn.sinTipo": "Ohne Mitgliedsart",
  "sn.condicionesGenerales": "Die allgemeinen Bedingungen des Clubs",
  "sn.alAnio": "pro Jahr",
  "sn.alAnioLaDelClub": "pro Jahr · der des Clubs",
  "sn.descuentoCatalogo": "−{porcentaje}% auf das Sortiment",
  "sn.sinDescuento": "Keine Ermäßigung",
  "sn.cobrarAhora": "Jetzt kassieren",
  "sn.sinCobrarla": "Ohne Kassieren bleibt das Mitglied ausstehend und kann erst beziehen, wenn es gezahlt hat.",
  "sn.formaDePago": "Zahlungsart",
  "sn.repaso": "Prüfen",
  "sn.r.nombre": "Name",
  "sn.r.documento": "Ausweis",
  "sn.r.nacimiento": "Geboren",
  "sn.r.consumo": "Angegebener Eigenbedarf",
  "sn.r.gMes": "{n} g/Monat",
  "sn.r.avalista": "Bürge",
  "sn.r.sinAvalista": "Kein Bürge",
  "sn.r.tipo": "Mitgliedsart",
  "sn.r.rgpd": "DSGVO",
  "sn.r.firmado": "Unterschrieben",
  "sn.r.pendiente": "Ausstehend",
  "sn.r.contrato": "Vertrag",
  "sn.r.pendienteFirma": "Unterschrift ausstehend",
  "sn.loQueSeCobra": "Was kassiert wird",
  "sn.cuotaAnual": "Jahresbeitrag",
  "sn.noSeCobraNada": "Jetzt wird nichts kassiert: das Mitglied bleibt ausstehend.",
  "sn.nadaQueCobrar": "Es gibt nichts zu kassieren.",
  "sn.seCobraEn": "Kassiert wird per {forma}.",
  "sn.mini.socio": "Mitglied",
  "sn.mini.frente": "Vorderseite",
  "sn.mini.reverso": "Rückseite",
  "sn.mini.firma": "Unterschrift",
  "sn.sinFoto": "Kein Foto",
  "sn.atras": "Zurück",
  "sn.creando": "Wird angelegt...",
  "sn.crear": "Mitglied anlegen",
  "sn.siguiente": "Weiter",
  "sn.fallo": "Das Mitglied konnte nicht angelegt werden",
  "sn.avisoSubida": "Das Mitglied ist angelegt, aber {que} konnte nicht hochgeladen werden.",
  "sn.subida.foto": "das Foto des Mitglieds",
  "sn.subida.frente": "die Vorderseite des Ausweises",
  "sn.subida.reverso": "die Rückseite des Ausweises",
  "sn.subida.firma": "die Unterschrift",
  "sn.seAsigna": "(wird beim Anlegen vergeben)",

  "se.titulo": "{socio} bearbeiten",
  "se.descripcion": "Mitglied Nummer {numero}",
  "se.guardarCambios": "Änderungen speichern",
  "se.datosPersonales": "Persönliche Daten",
  "se.nombre": "Vorname *",
  "se.apellidos": "Nachname *",
  "se.tipoDocumento": "Ausweisart",
  "se.numero": "Nummer *",
  "se.nacimiento": "Geburtsdatum *",
  "se.limitesPropios": "Eigene Limits",
  "se.sinLimites": "Wenn du sie leer lässt, gelten die des Clubs.",
  "se.sinLimitesConCifras": "Wenn du sie leer lässt, gelten die des Clubs ({diario} g am Tag, {mensual} g im Monat).",
  "se.limiteDiario": "Tageslimit (g)",
  "se.limiteMensual": "Monatslimit (g)",
  "se.delClub": "Club: {cantidad}",
  "se.asociacion": "Verein",
  "se.tipoDeSocio": "Mitgliedsart",
  "se.sinTipo": "Ohne Mitgliedsart (Bedingungen des Clubs)",
  "se.avalista": "Bürge",
  "se.buscarAvalista": "Bürge suchen...",
  "se.rgpd": "DSGVO-Einwilligung zur Datenverarbeitung unterschrieben",
  "se.fallo": "Die Änderungen konnten nicht gespeichert werden",

  "lb.volver": "Zurück zu den Mitgliedern",
  "lb.imprimir": "Drucken oder als PDF speichern",
  "lb.comoPdf":
    "Beim Drucken kommt nur das Dokument, ohne die Menüs. Um es als PDF zu speichern, wähle beim Druckziel «Als PDF speichern».",
  "lb.titulo": "Mitgliederverzeichnis",
  "lb.emision": "Auszug erstellt am {fecha} von {quien}.",
  "lb.numero": "Nr.",
  "lb.apellidosNombre": "Name, Vorname",
  "lb.documento": "Ausweis",
  "lb.nacimiento": "Geburtsdatum",
  "lb.alta": "Aufnahme",
  "lb.baja": "Austritt",
  "lb.avalista": "Bürge",
  "lb.rgpd": "DSGVO",
  "lb.estado": "Status",
  "lb.numeroAvalista": "Nr. {numero}",
  "lb.si": "Ja",
  "lb.sinSocios": "Im Verzeichnis ist noch kein Mitglied eingetragen.",
  "lb.unInscrito": "1 eingetragenes Mitglied",
  "lb.inscritos": "{n} eingetragene Mitglieder",
  "lb.enTotal": "insgesamt: {reparto}.",
  "lb.enAlta": "{n} aktiv",
  "lb.suspendidos": "{n} gesperrt",
  "lb.pendientes": "{n} Aufnahme ausstehend",
  "lb.bajas": "{n} ausgetreten",
  "lb.consentimiento": "Mit unterschriebener DSGVO-Einwilligung: {conConsentimiento} von {total}.",
  "lb.consumoDeclarado":
    "Von den aktiven Mitgliedern angegebener Eigenbedarf: {alMes} im Monat, das sind {alAnio} im Jahr. Das haben sie bei der Aufnahme als ihren Bedarf angegeben.",
  "lb.notaPie": "Internes Dokument des Vereins, erstellt aus dem Mitgliederverzeichnis zum angegebenen Datum.",

  "cn.preparando": "Mitgliedsausweise werden vorbereitet...",
  "cn.falloPreparar": "Die Mitgliedsausweise konnten nicht vorbereitet werden.",
  "cn.volver": "Zurück",
  "cn.unCarnet": "1 Mitgliedsausweis",
  "cn.carnets": "{n} Mitgliedsausweise",
  "cn.cuantos": "{carnets}, in Kartengröße: acht pro A4-Blatt.",
  "cn.cuantosTodos": "{carnets} (alle aktiven Mitglieder), in Kartengröße: acht pro A4-Blatt.",
  "cn.comoImprimir":
    "Beim Drucken kommt nur das Blatt mit den Ausweisen, ohne die Menüs; um es als PDF zu speichern, wähle beim Druckziel «Als PDF speichern».",
  "cn.elQr": "Der QR-Code ist derselbe wie im Mitgliederbereich: die Theke liest ihn genauso.",
  "cn.ninguno": "Es gibt kein Mitglied zum Drucken.",
  "cn.numero": "Nr. {numero}",
  "cn.validoHasta": "Gültig bis {fecha}",
  "cn.socioDesde": "Mitglied seit {fecha}",
  "cn.documentoInterno": "Internes Dokument des Vereins",

  "si.titulo": "Mitglieder importieren",
  "si.descripcion": "Hol das Mitgliederverzeichnis aus einem anderen Programm oder aus einer Tabelle",
  "si.volver": "Zurück",
  "si.importadoUno": "1 Mitglied importiert. Es steht schon im Verzeichnis.",
  "si.importados": "{n} Mitglieder importiert. Sie stehen schon im Verzeichnis.",
  "si.verSocios": "Mitglieder ansehen",
  "si.otroFichero": "Weitere Datei importieren",
  "si.paso1": "1. Datei vorbereiten",
  "si.explicacion":
    "Eine CSV mit einer Zeile pro Mitglied. Nötig sind mindestens «Vorname», «Nachname», «Ausweis» und «Geburtsdatum», auf Deutsch. Gibt es eine Spalte «Nummer», bleibt die bisherige Mitgliedsnummer erhalten; sonst werden die nächsten freien vergeben. Der Rest (Telefon, E-Mail, Adresse, Status, Aufnahmedatum, Mitgliedschaft bis, Notizen) wird übernommen, wenn er da ist. Die Datei, die dieses Programm selbst exportiert, passt auch.",
  "si.explicacionNombreEntero":
    "Wenn Vorname und Nachname zusammen in einer einzigen Spalte stehen («Vor- und Nachname», «Vollständiger Name»), trenne ich sie und zeige dir die Aufteilung, bevor irgendetwas gespeichert wird.",
  "si.explicacionColumnasDobles":
    "Und wenn es andersherum ist, auf zwei Spalten verteilt («Erster Nachname» und «Zweiter Nachname», oder «Erster Vorname» und «Zweiter Vorname»), füge ich sie zusammen.",
  "si.direccion": "Adresse",
  "si.direccionJuntada":
    "Die Adresse kam auf mehrere Spalten verteilt («Straße», «Nummer», «Etage»…) und ich habe sie in einer Zeile zusammengefügt, mit dem Wort deiner Datei vor jedem Teil. Hier siehst du sie ganz aufgeschlüsselt.",
  "si.numeroEnLaCalle":
    "Achtung bei der Spalte «Nummer»: weil die Datei die Adresse verteilt mitbringt, habe ich sie als Hausnummer gelesen und nicht als Mitgliedsnummer. Die Mitgliedsnummern werden ab der nächsten freien vergeben. Wenn in dieser Spalte deine Mitgliedsnummern standen, gib der Spalte mit der Hausnummer einen anderen Namen («Hausnummer») und lade die Datei noch einmal hoch.",
  "si.explicacionVarios":
    "Wenn es mehrere Spalten für dasselbe gibt («Telefon 1» und «Telefon 2»), nehme ich die erste: vom Mitglied wird eine Telefonnummer gespeichert, nicht drei.",
  "si.explicacionDireccion":
    "Die Adresse kann auf «Straße», «Nummer», «Etage» und «Tür» verteilt sein und der DNI auf Nummer und Buchstabe: das füge ich zusammen.",
  "si.formatos":
    "Datum im Format 2026-09-01 oder 01/09/2026. Trennzeichen «;» oder «,». Dateien, die Excel gespeichert hat, werden in jeder seiner Kodierungen angenommen.",
  "si.descargarPlantilla": "Vorlage herunterladen",
  "si.falloPlantilla": "Die Vorlage konnte nicht heruntergeladen werden",
  "si.paso2": "2. Datei auswählen und prüfen",
  "si.analizarNoGuarda": "Prüfen speichert nichts: es kontrolliert nur die Datei und sagt dir, was es findet.",
  "si.analizando": "Wird geprüft...",
  "si.analizar": "Prüfen",
  "si.paso3": "3. Ergebnis",
  "si.procesando": "Die Datei wird verarbeitet...",
  "si.eligeFichero": "Wähle eine Datei und drücke Prüfen.",
  "si.filas": "Zeilen",
  "si.validas": "Gültig",
  "si.conErrores": "Mit Fehlern",
  "si.columnas": "Erkannte Spalten: {columnas}",
  "si.corrige":
    "Korrigiere diese Zeilen in der Datei und prüfe sie noch einmal. Solange es Fehler gibt, wird nichts importiert.",
  "si.fila": "Zeile",
  "si.problema": "Problem",
  "si.numero": "Nr.",
  "si.socio": "Mitglied",
  "si.nombre": "Vorname",
  "si.apellidos": "Nachname",
  "si.columnasJuntadas":
    "Die Datei bringt den Nachnamen (oder den Vornamen) auf zwei Spalten verteilt, und ich habe sie zu einer zusammengefügt. Hier gibt es nichts zu raten, es kommt genau so heraus, wie es ankam; schau trotzdem kurz drüber, ob die Reihenfolge die ist, die du erwartet hast.",
  "si.nombrePartido":
    "Die Datei bringt Vorname und Nachname in derselben Spalte, und ich habe sie getrennt. Es geht kein Teil des Namens verloren, aber wo der Vorname aufhört und der Nachname anfängt, ist meine Annahme. Schau es dir hier vor dem Importieren an: wenn etwas falsch aufgeteilt ist, lässt es sich beim Bearbeiten des Mitglieds richtigstellen.",
  "si.documento": "Ausweis",
  "si.estado": "Status",
  "si.seMuestran": "Angezeigt werden {cuantos} von {total}.",
  "si.importarUno": "1 Mitglied importieren",
  "si.importarVarios": "{n} Mitglieder importieren",
  "si.falloLeer": "Die Datei konnte nicht gelesen werden",
  "si.falloImportar": "Es konnte nicht importiert werden",

  "sf.volver": "Zurück",
  "sf.carnet": "Mitgliedsausweis",
  "sf.editar": "Daten bearbeiten",
  "sf.dispensar": "Abgeben",
  "sf.unAnio": "1 Jahr",
  "sf.anios": "{n} Jahre",
  "sf.subiendo": "Wird hochgeladen...",
  "sf.cambiarFoto": "Foto ändern",
  "sf.anadirFoto": "Foto hinzufügen",
  "sf.quitarFoto": "Foto entfernen",
  "sf.falloQuitarFoto": "Das Foto konnte nicht entfernt werden",
  "sf.documento": "Ausweis",
  "sf.alta": "Aufnahme",
  "sf.cuotaHasta": "Mitgliedschaft bis",
  "sf.avalista": "Bürge",
  "sf.rgpd": "DSGVO-Einwilligung",
  "sf.portal": "Mitgliederbereich",
  "sf.activo": "Aktiv",
  "sf.sinAcceso": "Kein Zugang",
  "sf.cartera": "Guthabenkonto",
  "sf.recargar": "Aufladen",
  "sf.cobrarCuota": "Mitgliedsbeitrag kassieren",
  "sf.devolverSaldo": "Guthaben auszahlen",
  "sf.ajustarSaldo": "Guthaben korrigieren",
  "sf.suspender": "Vorübergehend sperren",
  "sf.levantar": "Sperre aufheben",
  "sf.falloLevantar": "Die Sperre konnte nicht aufgehoben werden",
  "sf.reactivar": "Mitglied reaktivieren",
  "sf.falloReactivar": "Das Mitglied konnte nicht reaktiviert werden",
  "sf.renovarPortal": "Zugang zum Mitgliederbereich erneuern",
  "sf.darPortal": "Zugang zum Mitgliederbereich geben",
  "sf.falloCodigo": "Der Code konnte nicht erzeugt werden",
  "sf.retirarPortal": "Zugang zum Mitgliederbereich entziehen",
  "sf.falloRetirar": "Der Zugang konnte nicht entzogen werden",
  "sf.darDeBaja": "Mitgliedschaft beenden",
  "sf.descargarDatos": "Daten des Mitglieds herunterladen",
  "sf.falloDescargar": "Die Daten konnten nicht heruntergeladen werden",
  "sf.borrarDatos": "Daten des Mitglieds löschen",
  "sf.consumoYLimites": "Bezugsmenge und Limits",
  "sf.hoy": "Heute",
  "sf.esteMes": "Diesen Monat",
  "sf.puedeRetirar": "Kann jetzt beziehen",
  "sf.consumoDeclarado": "Bei der Aufnahme angegebener Eigenbedarf",
  "sf.alMes": "{cantidad}/Monat",
  "sf.tab.resumen": "Übersicht",
  "sf.tab.dispensaciones": "Abgaben",
  "sf.tab.cartera": "Bewegungen",
  "sf.tab.cuotas": "Mitgliedsbeiträge",
  "sf.entregasRegistradas": "Erfasste Abgaben",
  "sf.ultimaVisita": "Letzter Besuch",
  "sf.cuotasPagadas": "Bezahlte Mitgliedsbeiträge",
  "sf.notas": "Interne Notizen",
  "sf.avalados": "Bürgt für",
  "sf.sinDispensaciones": "Dieses Mitglied hat noch nichts bezogen.",
  "sf.fecha": "Datum",
  "sf.productos": "Produkte",
  "sf.cantidad": "Menge",
  "sf.importe": "Betrag",
  "sf.anulada": "Storniert",
  "sf.sinCartera": "Keine Bewegungen auf dem Guthabenkonto.",
  "sf.concepto": "Vorgang",
  "sf.saldo": "Guthaben",
  "sf.sinCuotas": "Keine Mitgliedsbeiträge erfasst.",
  "sf.validaHasta": "Gültig bis",
  "sf.codigoPortal": "Code für den Mitgliederbereich",
  "sf.hecho": "Fertig",
  "sf.daleLosDatos": "Gib dem Mitglied diese Daten. Der Code läuft in 7 Tagen ab und gilt nur einmal.",
  "sf.numeroDeSocio": "Mitgliedsnummer",
  "sf.codigo": "Code",
  "sf.entraEn": "Geh auf {url} und wähle «Zugang aktivieren».",
  "sf.devolverTitulo": "Guthaben an das Mitglied auszahlen",
  "sf.devolverEtiqueta": "Auszuzahlender Betrag",
  "sf.ajustarTitulo": "Guthaben korrigieren",
  "sf.ajustarEtiqueta": "Betrag der Korrektur (negativ zum Abziehen)",
  "sf.bajaTitulo": "Mitgliedschaft beenden",
  "sf.bajaTexto":
    "Das Mitglied kann dann nichts mehr beziehen. Der Verlauf bleibt erhalten. Wenn noch Guthaben übrig ist, muss es vorher ausgezahlt werden.",
  "sf.suspenderTitulo": "Vorübergehend sperren",
  "sf.suspenderTexto":
    "Solange die Sperre gilt, kommt das Mitglied nicht herein und kann nichts beziehen. Aufgehoben wird sie hier auf derselben Seite.",
  "sf.suspenderBoton": "Sperren",
  "sf.comoMaximo": "Höchstens {importe} Credits.",
  "sf.confirmar": "Bestätigen",
  "sf.motivoObligatorio": "Grund (Pflicht)",
  "sf.motivo": "Grund",
  "sf.formaDePago": "Zahlungsart",
  "sf.falloAccion": "Die Aktion konnte nicht abgeschlossen werden",
  "sf.borrarTitulo": "Die Daten des Mitglieds löschen",
  "sf.borrando": "Wird gelöscht...",
  "sf.sinVuelta": "Das lässt sich nicht rückgängig machen.",
  "sf.seBorra": "Gelöscht wird:",
  "sf.seBorraLista":
    "Vorname, Nachname, Ausweis, Geburtsdatum, Telefon, E-Mail, Adresse, Foto, Notizen und der Zugang zum Mitgliederbereich.",
  "sf.seConserva": "Erhalten bleibt:",
  "sf.seConservaLista":
    "die Mitgliedsnummer und die Abgaben, Mitgliedsbeiträge, Bewegungen auf dem Guthabenkonto und Einlässe. Das sind die Buchhaltung und die Rückverfolgbarkeit des Clubs, und sie zu löschen würde das Verzeichnis durcheinanderbringen und die Spur der Chargen zerreißen. Sie bleiben erhalten, nur ohne Namen dahinter.",
  "sf.copiasDeSeguridad":
    "In den Datensicherungen von vor heute stehen die Daten weiterhin: sie verschwinden, wenn die Sicherungen ablaufen. Wenn das bei euch nicht reicht, besprecht es mit eurem Berater.",
  "sf.escribeNumero": "Schreib zur Bestätigung die Mitgliedsnummer ({numero})",
  "sf.falloBorrar": "Die Daten konnten nicht gelöscht werden",
  "sf.frente": "Vorderseite",
  "sf.reverso": "Rückseite",
  "sf.sinFoto": "Kein Foto",
  "sf.cambiar": "Ändern",
  "sf.subir": "Hochladen",

  "cu.titulo": "Mitgliedsbeiträge",
  "cu.descripcion": "Was an Mitgliedsbeiträgen kassiert wurde, und welche Mitgliedsarten es gibt",
  "cu.a": "bis",
  "cu.exportar": "CSV exportieren",
  "cu.falloExportar": "Konnte nicht exportiert werden",
  "cu.tabCobradas": "Kassiert",
  "cu.tabTipos": "Mitgliedsarten",
  "cu.cobradoEnPeriodo": "Im Zeitraum kassiert",
  "cu.unaCuota": "1 Mitgliedsbeitrag",
  "cu.cuotas": "{n} Mitgliedsbeiträge",
  "cu.altas": "Aufnahmen",
  "cu.altasPie": "Erste Mitgliedsbeiträge: neue Mitglieder",
  "cu.enEfectivo": "Bar",
  "cu.enEfectivoPie": "Kommt in die Kasse der Schicht",
  "cu.buscar": "Suche nach Mitglied, DNI oder Vorgang",
  "cu.altasYRenovaciones": "Aufnahmen und Verlängerungen",
  "cu.soloAltas": "Nur Aufnahmen",
  "cu.soloRenovaciones": "Nur Verlängerungen",
  "cu.cualquierTipo": "Jede Mitgliedsart",
  "cu.cualquierForma": "Beliebige Zahlungsart",
  "cu.cualquierPuesto": "Beliebiger Kassenplatz",
  "cu.sinCoincidencias": "Mit diesen Filtern wurde kein Mitgliedsbeitrag kassiert. Um zu sehen, wer dran ist,",
  "cu.miraRenovaciones": "schau unter Verlängerungen",
  "cu.fecha": "Datum",
  "cu.socio": "Mitglied",
  "cu.tipoDeSocio": "Mitgliedsart",
  "cu.altaORenovacion": "Aufnahme oder Verlängerung",
  "cu.periodo": "Zeitraum",
  "cu.forma": "Zahlungsart",
  "cu.puesto": "Kassenplatz",
  "cu.cobro": "Kassiert von",

  "cu.an.boton": "Storno",
  "cu.an.anulada": "Storniert",
  "cu.an.titulo": "Einen Beitrag über {importe} stornieren",
  "cu.an.queVaAPasar":
    "{socio} bekommt {importe} zurück und der Beitrag zählt nicht mehr: Das Datum, bis zu dem bezahlt ist, geht auf den vorherigen Beitrag zurück, und war dies der einzige, kann die Person nichts mehr abholen, bis wieder bezahlt wird.",
  "cu.an.deLaCartera": "Es wurde vom Guthaben bezahlt, also kommt es sofort wieder darauf.",
  "cu.an.delCajon":
    "Es wurde bar bezahlt, also geht das Geld aus der Lade, in die es kam. Ist diese Schicht schon abgerechnet, wird keine Kasse angefasst: Ihre Abrechnung wurde mit diesem Beitrag darin abgezeichnet.",
  "cu.an.motivo": "Grund",
  "cu.an.motivoAyuda":
    "Wird vermerkt. In einem halben Jahr ist das das Einzige, was das noch erklärt.",
  "cu.an.confirmar": "Beitrag stornieren",
  "cu.an.anulando": "Wird storniert…",
  "cu.an.fallo": "Der Beitrag konnte nicht storniert werden",
  "cu.importe": "Betrag",
  "cu.alta": "Aufnahme",
  "cu.renovacion": "Verlängerung",
  "cu.tiposTitulo": "Mitgliedsarten",
  "cu.tiposNota": "Jede Art hat ihren Mitgliedsbeitrag, ihre Laufzeit, ihre Ermäßigung und ihre Limits.",
  "cu.seEditanEnAjustes": "Angelegt und bearbeitet werden sie in den Einstellungen",
  "cu.sinTipos": "Keine Mitgliedsarten. Alle zahlen den allgemeinen Mitgliedsbeitrag des Clubs.",
  "cu.sinTiposConCuota":
    "Keine Mitgliedsarten. Alle zahlen den allgemeinen Mitgliedsbeitrag des Clubs, {importe} im Jahr.",
  "cu.tipo": "Art",
  "cu.cuota": "Mitgliedsbeitrag",
  "cu.dura": "Dauer",
  "cu.descuento": "Ermäßigung",
  "cu.socios": "Mitglieder",
  "cu.apagado": " · inaktiv",
  "cu.laDelClub": "der des Clubs",
  "cu.unAnio": "1 Jahr",
  "cu.anios": "{n} Jahre",
  "cu.unMes": "1 Monat",
  "cu.meses": "{n} Monate",

  "rn.titulo": "Verlängerungen",
  "rn.descripcion": "Mitglieder, deren Mitgliedschaft abgelaufen ist oder bald abläuft",
  "rn.vencenEnDias": "Ablauf innerhalb der nächsten {dias}",
  "rn.cuotaVencida": "Mitgliedschaft abgelaufen",
  "rn.noPuedenRetirar": "Können nichts beziehen",
  "rn.convieneAvisar": "Am besten erinnern",
  "rn.cuotaAnual": "Jahresbeitrag",
  "rn.nadieVencida": "Bei niemandem ist die Mitgliedschaft abgelaufen.",
  "rn.vencenEnLosProximos": "Laufen innerhalb der nächsten {dias} ab",
  "rn.ningunaVence": "Innerhalb der nächsten {dias} läuft keine Mitgliedschaft ab.",
  "rn.laAsociacion": "der Verein",
  "rn.cobrada": "Mitgliedsbeitrag von {socio} kassiert. Mitgliedschaft gültig bis {fecha}.",
  "rn.socio": "Mitglied",
  "rn.telefono": "Telefon",
  "rn.estado": "Status",
  "rn.cuotaHasta": "Mitgliedschaft bis",
  "rn.whatsapp": "WhatsApp",
  "rn.mensajeWhatsapp":
    "Hallo {nombre}, hier meldet sich {club}. Dein Mitgliedsbeitrag ist fällig. Komm vorbei, wenn du kannst. Danke.",
  "rn.sinCuota": "Kein Mitgliedsbeitrag",
  "rn.vencioHace": "schon {dias} abgelaufen",
  "rn.venceHoy": "läuft heute ab",
  "rn.queda": "noch {dias}",
  "rn.quedan": "noch {dias}",
  "rn.cobrarCuota": "Mitgliedsbeitrag kassieren",
  "rn.nadieAQuienAvisar":
    "Es war niemand zu erinnern: Entweder wurden sie zu diesem Mitgliedsbeitrag schon erinnert, oder die Mitgliedschaft läuft noch nicht ab.",
  "rn.avisadoUno": "1 Mitglied erinnert ({porCorreo} per E-Mail, {porMovil} aufs Handy).",
  "rn.avisados": "{n} Mitglieder erinnert ({porCorreo} per E-Mail, {porMovil} aufs Handy).",
  "rn.unoSinCorreo": "1 Mitglied hat keine E-Mail hinterlegt.",
  "rn.sinCorreo": "{n} Mitglieder haben keine E-Mail hinterlegt.",
  "rn.falloRecordatorios": "Die Erinnerungen konnten nicht gesendet werden",
  "rn.enviando": "Wird gesendet...",
  "rn.avisar": "Erinnerungen senden",

  "gc.gastos": "Ausgaben",
  "gc.compras": "Einkäufe",
  "gc.proveedores": "Lieferanten",

  "pago.DOMICILIADO": "Lastschrift",

  "ga.titulo": "Ausgaben und Einkäufe",
  "ga.descripcion": "Was aus dem Verein rausgeht, mit seiner Kategorie",
  "ga.a": "bis",
  "ga.categorias": "Kategorien",
  "ga.exportar": "CSV exportieren",
  "ga.falloExportar": "Konnte nicht exportiert werden",
  "ga.nuevo": "+ Ausgabe",
  "ga.totalFiltrado": "Summe der Auswahl",
  "ga.totalPeriodo": "Summe im Zeitraum",
  "ga.unApunte": "1 Eintrag",
  "ga.apuntes": "{n} Einträge",
  "ga.enEfectivo": "Bar",
  "ga.saleDeCaja": "Geht aus der Kasse der Schicht raus",
  "ga.categoriaMayor": "Größte Kategorie",
  "ga.porCategoria": "Nach Kategorie",
  "ga.sinGastos": "Keine Ausgaben in diesem Zeitraum.",
  "ga.gastosDe": "Ausgaben für {categoria}",
  "ga.todosLosGastos": "Alle Ausgaben",
  "ga.buscar": "Nach Zweck, Lieferant oder Notiz suchen",
  "ga.todasCategorias": "Alle Kategorien",
  "ga.apagada": " (inaktiv)",
  "ga.cualquierForma": "Beliebige Zahlungsart",
  "ga.cualquierPuesto": "Beliebiger Kassenplatz",
  "ga.conPagosProveedor": "Mit den Zahlungen an Lieferanten",
  "ga.verAnulados": "Stornierte anzeigen",
  "ga.sinCoincidencias": "Keine Ausgabe mit diesen Filtern.",
  "ga.sinApuntes": "In diesem Zeitraum wurden keine Ausgaben erfasst.",
  "ga.numero": "Nr.",
  "ga.fecha": "Datum",
  "ga.concepto": "Zweck",
  "ga.categoria": "Kategorie",
  "ga.pago": "Zahlung",
  "ga.puesto": "Kassenplatz",
  "ga.importe": "Betrag",
  "ga.compraNumero": " · Einkauf #{numero}",
  "ga.anulado": "Storniert",
  "ga.anuladoPor": "Storniert: {motivo}",
  "ga.editar": "Bearbeiten",
  "ga.anular": "Stornieren",
  "ga.d.editar": "Ausgabe bearbeiten",
  "ga.d.nuevo": "Neue Ausgabe",
  "ga.d.fallo": "Die Ausgabe konnte nicht gespeichert werden",
  "ga.d.concepto": "Zweck",
  "ga.d.conceptoEjemplo": "Stromrechnung",
  "ga.d.importe": "Betrag (Credits)",
  "ga.d.fecha": "Datum",
  "ga.d.categoria": "Kategorie",
  "ga.d.formaDePago": "Zahlungsart",
  "ga.d.saldraDeCaja": "Geht aus der offenen Kasse raus.",
  "ga.d.proveedor": "Lieferant",
  "ga.d.notas": "Notizen",
  "ga.d.editarNota":
    "Wenn du eine Ausgabe bearbeitest, ändert sich die damals gebuchte Kassenbewegung nicht: Der Kassensturz jener Schicht ist längst abgeschlossen.",
  "ga.an.titulo": "Ausgabe #{numero} stornieren",
  "ga.an.fallo": "Konnte nicht storniert werden",
  "ga.an.motivo": "Grund",
  "ga.an.motivoAyuda": "Steht dann neben der Ausgabe, damit man es beim Durchsehen des Monats versteht.",
  "ga.an.motivoEjemplo": "Der Betrag war falsch",
  "ga.an.noSeBorra": "Sie wird nicht gelöscht: Sie bleibt durchgestrichen in der Liste.",
  "ga.an.vuelveALaCaja": " Das Geld geht zurück in die offene Kasse.",
  "ga.an.compraNoPagada": " Der Einkauf #{numero} gilt dann wieder als nicht bezahlt.",
  "ga.c.titulo": "Ausgabenkategorien",
  "ga.c.listo": "Fertig",
  "ga.c.fallo": "Hat nicht geklappt",
  "ga.c.ejemplo": "Wasser, Löhne, Beratung...",
  "ga.c.anadir": "Hinzufügen",
  "ga.c.unGasto": "1 Ausgabe",
  "ga.c.gastos": "{n} Ausgaben",
  "ga.c.apagadaNota": "Inaktiv · wird beim Erfassen nicht angeboten",
  "ga.c.seApagara": "Wird inaktiv: Es hängen Ausgaben dran",
  "ga.c.quitarla": "Entfernen",
  "ga.c.quitar": "Entfernen",
  "ga.c.volverAUsar": "Wieder verwenden",
  "ga.c.nota":
    "Eine Kategorie mit Ausgaben darin wird inaktiv statt gelöscht: So sagen die Einträge aus früheren Jahren weiter, worum es ging.",

  "co.titulo": "Ausgaben und Einkäufe",
  "co.descripcion": "Einkäufe beim Lieferanten, was ankommt und was noch offen ist",
  "co.nuevaCompra": "+ Einkauf",
  "co.nuevoProveedor": "+ Lieferant",
  "co.antesDeLaPrimera":
    "Vor dem ersten Einkauf muss der Lieferant angelegt werden: So ist er nicht nur ein loser Name, und man sieht, was er gebracht hat und was man ihm noch schuldet.",
  "co.pendienteDePagar": "Ausstehende Zahlungen",
  "co.aTodos": "An alle Lieferanten",
  "co.pedidasSinRecibir": "Bestellt, noch nicht da",
  "co.enCamino": "Beauftragt und noch unterwegs",
  "co.sinProveedores": "Noch keine Lieferanten da.",
  "co.proveedor": "Lieferant",
  "co.contacto": "Kontakt",
  "co.compras": "Einkäufe",
  "co.seLeDebe": "Offen",
  "co.sinCompras":
    "Noch keine Einkäufe da. Sobald einer ankommt, geht seine Ware von allein mit Einkaufspreis und Lieferant ins Lager, ohne dass man sie dort noch einmal eintippen muss.",
  "co.pedida": "Bestellt",
  "co.recibida": "Angekommen",
  "co.anulada": "Storniert",
  "co.debe": "{importe} offen",
  "co.pagada": "Bezahlt",
  "co.recibidaEl": " · angekommen am {fecha}",
  "co.noEsGenero": " · keine Ware",
  "co.haLlegado": "Ist angekommen",
  "co.anular": "Stornieren",
  "co.an.titulo": "Einkauf #{numero} stornieren",
  "co.an.quePasa":
    "Der Einkauf wird storniert und zählt nicht mehr zu dem, was du dem Lieferanten schuldest. Der Bestand bleibt unverändert: die Ware war noch nicht da.",
  "co.an.motivo": "Grund (optional)",
  "co.an.confirmar": "Einkauf stornieren",
  "co.an.fallo": "Der Einkauf konnte nicht storniert werden",
  "co.an.hecho": "Einkauf #{numero} storniert",
  "co.pagar": "Bezahlen",
  "co.recibidaConLotes": "Einkauf #{numero} angekommen. {lotes} im Lager.",
  "co.recibidaSinLotes": "Einkauf #{numero} angekommen.",
  "co.unLote": "1 Charge",
  "co.lotes": "{n} Chargen",
  "co.falloRecibir": "Konnte nicht angenommen werden",
  "co.p.titulo": "Neuer Lieferant",
  "co.p.fallo": "Konnte nicht gespeichert werden",
  "co.p.nombre": "Name",
  "co.p.cif": "Steuernummer oder USt-IdNr.",
  "co.p.telefono": "Telefon",
  "co.p.email": "E-Mail",
  "co.p.notas": "Notizen",
  "co.n.titulo": "Neuer Einkauf",
  "co.n.fallo": "Der Einkauf konnte nicht gespeichert werden",
  "co.n.registrar": "Erfassen · {importe}",
  "co.n.proveedor": "Lieferant",
  "co.n.referencia": "Lieferschein oder Rechnung",
  "co.n.referenciaAyuda": "Optional, die Nummer, die auf dem Papier steht.",
  "co.n.queSeCompra": "Was eingekauft wird",
  "co.n.explicacion":
    "Zeilen, die auf ein Produkt aus dem Sortiment zeigen, legen beim Eintreffen des Einkaufs ihre Charge an. Der Rest — Dosen, Etiketten, eine Waage — ist Ausgabe und rührt den Bestand nicht an.",
  "co.n.producto": "Produkt",
  "co.n.noEsGenero": "Keine Ware",
  "co.n.descripcion": "Beschreibung",
  "co.n.gramos": "Gramm",
  "co.n.coste": "Einkaufspreis (Credits)",
  "co.n.otraLinea": "+ Weitere Zeile",
  "co.n.quitarUltima": "Letzte entfernen",
  "co.g.titulo": "Einkauf #{numero} bezahlen",
  "co.g.fallo": "Die Zahlung konnte nicht erfasst werden",
  "co.g.registrar": "Zahlung erfassen",
  "co.g.quedanPorPagar": "Von diesem Einkauf sind noch {importe} an {proveedor} offen.",
  "co.g.importe": "Betrag (Credits)",
  "co.g.aPlazos": "Man kann in Raten zahlen.",
  "co.g.formaDePago": "Zahlungsart",
  "co.g.comoGasto":
    "Die Zahlung wird als Ausgabe zu diesem Einkauf erfasst, damit das Geld in den Büchern nur einmal rausgeht.",
  "co.g.enEfectivo": "Bar geht es aus der Kasse der Schicht raus.",

  "do.titulo": "Spenden und Einzahlungen",
  "do.descripcion": "Was dem Club gegeben wird und was die Leute auf ihr Guthabenkonto legen, um es hier auszugeben",
  "do.a": "bis",
  "do.exportar": "CSV exportieren",
  "do.falloExportar": "Konnte nicht exportiert werden",
  "do.nueva": "+ Spende",
  "do.tabDonaciones": "Spenden",
  "do.tabCartera": "Einzahlungen aufs Guthabenkonto",
  "do.deSuCartera": "Vom Guthabenkonto",
  "do.donadoEnPeriodo": "Gespendet im Zeitraum",
  "do.unaDonacion": "1 Spende",
  "do.donaciones": "{n} Spenden",
  "do.sinNombre": "Ohne Namen",
  "do.delBote": "Aus der Spendendose, ohne Mitglied dahinter",
  "do.enEfectivo": "Bar",
  "do.entraEnCaja": "Kommt in die Kasse der Schicht",
  "do.ingresadoEnPeriodo": "Eingezahlt im Zeitraum",
  "do.unIngreso": "1 Einzahlung",
  "do.ingresos": "{n} Einzahlungen",
  "do.clubDebe": "Der Club schuldet jetzt",
  "do.saldoVivo": "Offenes Guthaben auf allen Guthabenkonten",
  "do.buscar": "Nach Mitglied oder Zweck suchen",
  "do.cualquierForma": "Beliebige Zahlungsart",
  "do.cualquierPuesto": "Beliebiger Kassenplatz",
  "do.verAnuladas": "Stornierte anzeigen",
  "do.sinDonaciones":
    "Keine Spende mit diesen Filtern. Spenden sind für Geld, das jemand dem Club gibt und das weder sein Mitgliedsbeitrag noch die Pauschale für das Bezogene ist.",
  "do.numero": "Nr.",
  "do.fecha": "Datum",
  "do.quien": "Wer",
  "do.concepto": "Zweck",
  "do.forma": "Zahlungsart",
  "do.puesto": "Kassenplatz",
  "do.atendio": "Bedient von",
  "do.importe": "Betrag",
  "do.anonima": "Anonym",
  "do.anulada": "Storniert",
  "do.anular": "Stornieren",
  "do.sinIngresos":
    "Mit diesen Filtern hat niemand Geld auf sein Guthabenkonto eingezahlt. Eingezahlt wird auf der Seite des Mitglieds oder an der Theke.",
  "do.socio": "Mitglied",
  "do.loCobro": "Kassiert von",
  "do.ingresado": "Eingezahlt",
  "do.saldoDespues": "Guthaben danach",
  "do.sinDato": "Keine Angabe",
  "do.r.titulo": "Eine Spende erfassen",
  "do.r.fallo": "Die Spende konnte nicht erfasst werden",
  "do.r.registrar": "Erfassen",
  "do.r.quienDona": "Wer spendet",
  "do.r.quienDonaAyuda": "Kann leer bleiben: Manche werfen Geld in die Dose, ohne ihren Namen zu nennen.",
  "do.r.quitar": "Entfernen",
  "do.r.buscarSocio": "Mitglied suchen oder leer lassen",
  "do.r.importe": "Betrag (Credits)",
  "do.r.formaDePago": "Zahlungsart",
  "do.r.faltaSocio": "Für eine Spende vom Guthabenkonto musst du sagen, von welchem Mitglied.",
  "do.r.efectivoNota": "Kommt in die Kasse der Schicht. Die anderen Zahlungsarten rühren sie nicht an.",
  "do.r.concepto": "Zweck",
  "do.r.conceptoAyuda": "Optional. Zum Beispiel: Spendendose am Tresen, Tombola, Extra-Spende.",
  "do.an.titulo": "Die Spende stornieren",
  "do.an.fallo": "Konnte nicht storniert werden",
  "do.an.anulando": "Wird storniert...",
  "do.an.anular": "Stornieren",
  "do.an.explicacion":
    "{importe} werden storniert. Die Spende wird nicht gelöscht: Sie wird als storniert markiert und zählt in den Büchern nicht mehr mit. Eine Einzahlung, die aus dem Verlauf verschwindet, ist ein Loch im Kassensturz.",
  "do.an.efectivo": "Das Geld geht mit einem eigenen Eintrag aus der offenen Kasse raus.",
  "do.an.cartera": "Das Guthaben geht zurück ans Mitglied.",
  "do.an.motivo": "Grund",
  "do.an.motivoAyuda": "Optional, hilft aber, es in sechs Monaten noch zu verstehen.",

  "semana.1c": "Mo",
  "semana.2c": "Di",
  "semana.3c": "Mi",
  "semana.4c": "Do",
  "semana.5c": "Fr",
  "semana.6c": "Sa",
  "semana.0c": "So",
  "semana.1": "Montag",
  "semana.2": "Dienstag",
  "semana.3": "Mittwoch",
  "semana.4": "Donnerstag",
  "semana.5": "Freitag",
  "semana.6": "Samstag",
  "semana.0": "Sonntag",

  "de.titulo": "Ermäßigungen",
  "de.descripcion": "Aktionen nach Kategorie, Produkt, Mitgliedsart, Tag und Zeitfenster",
  "de.nuevo": "+ Ermäßigung",
  "de.unoSolo": "nur eine Ermäßigung, die höchste",
  "de.noSeAcumulan":
    "passende: sie werden weder untereinander noch mit der allgemeinen Ermäßigung der Mitgliedsart kombiniert.",
  "de.enCadaEntrega": "Bei jeder Abgabe gilt",
  "de.sinDescuentos": "Keine Ermäßigungen. Leg eine an, zum Beispiel 15 % auf Blüten an einem Nachmittag.",
  "de.nombre": "Name",
  "de.descuento": "Ermäßigung",
  "de.aplicaA": "Gilt für",
  "de.cuando": "Wann",
  "de.estado": "Status",
  "de.categoriaNombre": "Kategorie {nombre}",
  "de.todoElCatalogo": "Ganzes Sortiment",
  "de.soloTipo": "Nur {tipo}",
  "de.todosLosDias": "Täglich",
  "de.activo": "Aktiv",
  "de.apagado": "Aus",
  "de.editar": "Bearbeiten",
  "de.borrar": "Löschen",
  "de.falloBorrar": "Löschen fehlgeschlagen",
  "de.d.editar": "{nombre} bearbeiten",
  "de.d.nuevo": "Neue Ermäßigung",
  "de.d.fallo": "Ermäßigung konnte nicht gespeichert werden",
  "de.d.nombre": "Name",
  "de.d.nombreAyuda": "Steht auf dem Beleg, z. B. „Ruhiger Nachmittag“.",
  "de.d.porcentaje": "Ermäßigung (%)",
  "de.d.categoria": "Kategorie",
  "de.d.categoriaAyuda": "Leer = alle.",
  "de.d.todas": "Alle",
  "de.d.producto": "Bestimmtes Produkt",
  "de.d.productoAyuda": "Leer = alle der Kategorie.",
  "de.d.todos": "Alle",
  "de.d.tipoSocio": "Nur für eine Mitgliedsart",
  "de.d.tipoSocioAyuda": "Leer = für alle.",
  "de.d.todosLosSocios": "Alle Mitglieder",
  "de.d.dias": "Wochentage",
  "de.d.diasAyuda": "Keiner markiert = täglich.",
  "de.d.desdeLas": "Ab",
  "de.d.franjaAyuda": "Zeitfenster; leer = ganzer Tag.",
  "de.d.hastaLas": "Bis",
  "de.d.fechaInicio": "Startdatum",
  "de.d.fechaAyuda": "Leer = ohne Begrenzung.",
  "de.d.fechaFin": "Enddatum",
  "de.d.activo": "Aktiv",

  "ca.titulo": "Anzeigetafeln",
  "ca.descripcion": "Was die Mitglieder auf dem Bildschirm im Club oder beim Scannen eines QR-Codes sehen",
  "ca.dispensario": "Abgabestelle",
  "ca.barra": "Tresen",
  "ca.sinCartaBarra": "Keine Getränkekarte. Wenn ihr Getränke oder Essen verkauft, zeigt ihr die Liste hier.",
  "ca.sinCartaDispensario": "Keine Anzeigetafel für die Abgabestelle.",
  "ca.principalAyuda": "Die, die auf dem Bildschirm im Club läuft",
  "ca.principal": "★ Haupttafel",
  "ca.apagada": "Aus",
  "ca.creadaEl": "Erstellt am {fecha}",
  "ca.nCategorias": " · {n} Kategorien",
  "ca.verQr": "QR-Code und Link ansehen",
  "ca.qr": "QR",
  "ca.editar": "Bearbeiten",
  "ca.nuevaDe": "+ Tafel für {zona}",
  "ca.laPrincipal": "Haupttafel",
  "ca.notaPrincipal1": "Die",
  "ca.notaPrincipal2":
    "jedes Bereichs läuft auf dem Bildschirm im Club. Die anderen öffnen sich über ihren eigenen Link, für einen QR-Code auf den Tischen oder zum Verschicken.",
  "ca.fallo": "Hat nicht geklappt",
  "ca.n.titulo": "Neue Anzeigetafel",
  "ca.n.nombreBarra": "Getränkekarte",
  "ca.n.nombreDispensario": "Anzeigetafel der Abgabestelle",
  "ca.n.crear": "Anlegen",
  "ca.n.fallo": "Anlegen fehlgeschlagen",
  "ca.n.nombre": "Name",
  "ca.n.nombreAyuda": "Seht nur ihr, um sie auseinanderzuhalten.",
  "ca.n.avisoBarra": "Zeigt, was ihr am Tresen angelegt habt.",
  "ca.n.avisoDispensario": "Zeigt alles mit Bestand. Danach kannst du sie auf einzelne Kategorien beschränken.",
  "ca.e.nombre": "Name",
  "ca.e.mensaje": "Nachricht",
  "ca.e.mensajeAyuda": "Steht ganz oben. Zum Beispiel: Öffnungszeiten oder etwas Neues.",
  "ca.e.categorias": "Kategorien, die sie zeigt",
  "ca.e.categoriasAyuda": "Keine markiert: sie zeigt alle.",
  "ca.e.encendida": "An",
  "ca.e.encendidaAyuda": "Wenn sie aus ist, öffnet ihr Link nicht mehr. Gelöscht wird nichts.",
  "ca.e.ponerlaEnPantalla": "Auf dem Bildschirm im Club zeigen",
  "ca.e.hacerlaPrincipal": "★ Zur Haupttafel machen",
  "ca.e.yaNoLaUsais": "Ihr nutzt sie nicht mehr",
  "ca.e.confirmarBorrar": "Anzeigetafel „{nombre}“ löschen? Ihr Link öffnet dann nicht mehr.",
  "ca.e.borrar": "Löschen",
  "ca.e.falloBorrar": "Löschen fehlgeschlagen",
  "ca.e.falloGuardar": "Konnte nicht gespeichert werden",
  "ca.q.titulo": "QR-Code von {nombre}",
  "ca.q.apagada": "Diese Anzeigetafel ist aus: der Link öffnet erst, wenn du sie anschaltest.",
  "ca.q.enlace": "Link",
  "ca.q.siSeHaFiltrado": "Wenn der Link durchgesickert ist",
  "ca.q.confirmarRenovar": "Es wird ein neuer Link erstellt, der jetzige öffnet dann nicht mehr. Weiter?",
  "ca.q.cambiarEnlace": "Link wechseln",
  "ca.q.soloEsta": "Das ändert nur den Link dieser Anzeigetafel. Die anderen laufen weiter.",

  "pd.volver": "Zurück",
  "pd.entradasYMermas": "Zugänge und Schwund",
  "pd.stock": "Bestand",
  "pd.minimo": "Mindestbestand {cantidad}",
  "pd.sinMinimo": "Kein Mindestbestand festgelegt",
  "pd.aportacion": "Pauschale",
  "pd.costeMedio": "Mittlerer Einkaufspreis",
  "pd.sinCoste": "Die Chargen haben keinen Einkaufspreis",
  "pd.segunLotes": "Nach den Chargen mit Einkaufspreis",
  "pd.thcCbd": "THC / CBD",
  "pd.disponible": "An der Theke verfügbar",
  "pd.retirado": "Von der Theke genommen",
  "pd.lotes": "Chargen",
  "pd.sinLotes": "Dieses Produkt hat keine Chargen: der Bestand kam per Bestandskorrektur, ohne Herkunft.",
  "pd.lote": "Charge",
  "pd.entrada": "Zugang",
  "pd.origen": "Herkunft",
  "pd.inicial": "Anfangsmenge",
  "pd.queda": "Rest",
  "pd.coste": "Einkaufspreis",
  "pd.caducidad": "MHD",
  "pd.estado": "Status",
  "pd.consumido": "{n} % verbraucht",
  "pd.agotado": "Aufgebraucht",
  "pd.caducado": "Abgelaufen",
  "pd.enUso": "In Gebrauch",
  "pd.ultimosMovimientos": "Letzte Bewegungen",
  "pd.sinMovimientos": "Keine Bewegungen.",
  "pd.fecha": "Datum",
  "pd.tipo": "Art",
  "pd.detalle": "Detail",
  "pd.cantidad": "Menge",
  "pd.stockDespues": "Bestand danach",
  "pd.usuario": "Benutzer",

  "re.titulo": "Inventuren",
  "re.descripcion": "Wiegen, was da ist, und mit dem vergleichen, was da sein müsste",
  "re.a": "bis",
  "re.empezar": "+ Inventur starten",
  "re.falloEmpezar": "Inventur konnte nicht gestartet werden",
  "re.cuadra": "Stimmt",
  "re.enMarcha": "Inventur #{numero} läuft",
  "re.empezado": "Gestartet {cuando} von {quien}. {contados} von {total} gezählt.",
  "re.alguien": "jemand",
  "re.conLocalCerrado":
    "Zähl bei geschlossenem Club, wenn es geht. Was währenddessen abgegeben wird, geht nicht verloren, aber die Abweichung wird sauberer.",
  "re.seguirContando": "Weiterzählen",
  "re.delPeriodo": "Inventuren im Zeitraum",
  "re.cerrados": "Abgeschlossen",
  "re.todaviaNinguno": "Noch keine",
  "re.descuadreAcumulado": "Abweichung gesamt",
  "re.sumandoTodos": "Alle im Zeitraum zusammen",
  "re.elPeor": "Die schlechteste",
  "re.elDiaQueMas": "Der Tag mit der größten Abweichung",
  "re.sinCerrados":
    "Keine abgeschlossenen Inventuren in diesem Zeitraum. Eine Inventur heißt: beim Schließen alles wiegen und schauen, ob es mit dem Programm stimmt.",
  "re.numero": "Nr.",
  "re.cuando": "Wann",
  "re.quien": "Wer",
  "re.contados": "Gezählt",
  "re.saltados": "Übersprungen",
  "re.descuadre": "Abweichung",
  "re.seCorrigio": "Korrigiert",
  "re.tardo": "Dauer",
  "re.si": "Ja",
  "re.no": "Nein",
  "re.unMinuto": "1 Minute",
  "re.minutos": "{n} Minuten",
  "re.ver": "Ansehen",
  "re.d.titulo": "Inventur #{numero}",
  "re.d.recuento": "Inventur",
  "re.d.seguirLuego": "Später weiter",
  "re.d.cerrarRecuento": "Inventur abschließen",
  "re.d.contadosDe": "{contados} von {total} gezählt",
  "re.d.nSaltados": " · {n} übersprungen",
  "re.d.saltarLoQueQueda": "Rest überspringen ({n})",
  "re.d.descuadre": "Abweichung:",
  "re.d.producto": "Produkt",
  "re.d.deberiaHaber": "Soll",
  "re.d.hay": "Ist",
  "re.d.saltarElResto": "Rest überspringen",
  "re.d.saltado": "Übersprungen",
  "re.d.volverAContar": "Nochmal zählen",
  "re.d.saltarEste": "Dieses Produkt überspringen",
  "re.d.contar": "Zählen",
  "re.d.saltar": "Überspringen",
  "re.d.notas": "Notizen:",
  "re.d.seCorrigio": "Beim Abschließen wurde der Bestand auf das Gezählte korrigiert.",
  "re.d.noSeCorrigio": "Abgeschlossen ohne den Bestand zu korrigieren: die Abweichung ist nur notiert.",
  "re.d.falloSaltar": "Überspringen fehlgeschlagen",
  "re.d.falloApuntar": "Eintragen fehlgeschlagen",
  "re.c.titulo": "Inventur abschließen",
  "re.c.volver": "Zurück",
  "re.c.cerrando": "Wird abgeschlossen...",
  "re.c.cerrar": "Abschließen",
  "re.c.fallo": "Abschließen fehlgeschlagen",
  "re.c.hasContadoUno": "Du hast 1 Produkt gezählt, die Abweichung beträgt",
  "re.c.hasContado": "Du hast {n} Produkte gezählt, die Abweichung beträgt",
  "re.c.corregir": "Bestand auf das Gezählte korrigieren",
  "re.c.corregirAyuda":
    "Die Differenz wird auf den jetzigen Bestand gerechnet: wurde beim Zählen etwas abgegeben, zählt diese Abgabe weiter mit. Jede Korrektur hinterlässt ihren Eintrag im Lager.",
  "re.c.notas": "Notizen",
  "re.c.notasAyuda": "Zum Beispiel: warum etwas fehlt, oder was ungeprüft blieb.",
  "re.c.noSeBorra":
    "Eine abgeschlossene Inventur wird nicht gelöscht: sie ist der Nachweis für die Abweichung an diesem Tag.",

  "ct.titulo": "Sortiment",
  "ct.descripcion": "Sorten und Produkte, die der Club abgibt",
  "ct.importar": "CSV importieren",
  "ct.marcas": "Marken",
  "ct.nuevaCategoria": "+ Kategorie",
  "ct.nuevoProducto": "+ Produkt",
  "ct.sinProductos":
    "Noch keine Produkte im Sortiment. Die Kategorien stehen schon: es fehlt nur, was ihr abgebt, mit seiner Pauschale.",
  "ct.producto": "Produkt",
  "ct.categoria": "Kategorie",
  "ct.genetica": "Genetik",
  "ct.thcCbd": "THC / CBD",
  "ct.precio": "Pauschale",
  "ct.stock": "Bestand",
  "ct.estado": "Status",
  "ct.bajoMinimo": "unter Mindestbestand",
  "ct.activo": "Aktiv",
  "ct.inactivo": "Inaktiv",
  "ct.editar": "Bearbeiten",
  "ct.p.editar": "{nombre} bearbeiten",
  "ct.p.nuevo": "Neues Produkt",
  "ct.p.fallo": "Produkt konnte nicht gespeichert werden",
  "ct.p.nombre": "Name",
  "ct.p.categoria": "Kategorie",
  "ct.p.marca": "Marke",
  "ct.p.sinMarcasAun": "Du hast noch keine angelegt.",
  "ct.p.sinMarca": "Ohne Marke",
  "ct.p.genetica": "Genetik",
  "ct.p.sinEspecificar": "Ohne Angabe",
  "ct.p.thc": "THC-Gehalt (%)",
  "ct.p.cbd": "CBD-Gehalt (%)",
  "ct.p.aportacionUnidad": "Pauschale pro Einheit (Credits)",
  "ct.p.aportacionGramo": "Pauschale pro Gramm (Credits)",
  "ct.p.stockMinimo": "Mindestbestand ({unidad})",
  "ct.p.stockMinimoAyuda": "Warnt, wenn der Bestand darunter fällt.",
  "ct.p.precioPorTipo": "Feste Pauschale je Mitgliedsart",
  "ct.p.sustituye": "Ersetzt die aus dem Sortiment; die Ermäßigung der Mitgliedsart kommt nicht obendrauf.",
  "ct.p.vacioConDescuento": "Leer: Sortiment mit −{porcentaje} %",
  "ct.p.vacioCatalogo": "Leer: Pauschale aus dem Sortiment",
  "ct.p.descripcion": "Beschreibung",
  "ct.p.disponible": "An der Theke verfügbar",
  "ct.c.titulo": "Neue Kategorie",
  "ct.c.fallo": "Kategorie konnte nicht angelegt werden",
  "ct.c.crear": "Anlegen",
  "ct.c.nombre": "Name",
  "ct.c.color": "Farbe",
  "ct.c.seDispensaPor": "Abgabe nach",
  "ct.c.peso": "Gewicht (Gramm)",
  "ct.c.unidades": "Stück",
  "ct.m.titulo": "Marken",
  "ct.m.listo": "Fertig",
  "ct.m.fallo": "Hat nicht geklappt",
  "ct.m.ejemplo": "Cookies, Green House, Eigenanbau...",
  "ct.m.anadir": "Hinzufügen",
  "ct.m.sinMarcas": "Keine Marken. Sie zeigen, von wem die Ware stammt; wenn ihr selbst anbaut, braucht ihr das nicht.",
  "ct.m.unProducto": "1 Produkt",
  "ct.m.productos": "{n} Produkte",
  "ct.m.apagada": "Aus",
  "ct.m.apagar": "Ausschalten",
  "ct.m.encender": "Einschalten",
  "ct.m.confirmarConProductos": "{productos} bleiben ohne Marke. Sonst wird nichts gelöscht. Weiter?",
  "ct.m.confirmarBorrar": "Marke „{nombre}“ löschen?",
  "ct.m.borrar": "Löschen",
  "ct.m.nota":
    "Ausschalten nimmt sie nur aus der Auswahlliste, die Produkte behalten sie. Löschen lässt diese Produkte ohne Marke, mehr passiert nicht.",

  "ci2.titulo": "Sortiment importieren",
  "ci2.descripcion": "Hol dir eure Produkte und euren Bestand aus einem anderen Programm oder aus einer Tabelle",
  "ci2.volver": "Zurück",
  "ci2.importadoUno": "1 Produkt importiert. Es steht jetzt im Sortiment und an der Theke.",
  "ci2.importadoUnoConStock":
    "1 Produkt importiert, sein Bestand als Eingangscharge. Es steht jetzt im Sortiment und an der Theke.",
  "ci2.importados": "{n} Produkte importiert. Sie stehen jetzt im Sortiment und an der Theke.",
  "ci2.importadosConStock":
    "{n} Produkte importiert, {conStock} davon mit ihrem Bestand als Eingangscharge. Sie stehen jetzt im Sortiment und an der Theke.",
  "ci2.verCatalogo": "Sortiment ansehen",
  "ci2.verInventario": "Lager ansehen",
  "ci2.otroFichero": "Weitere Datei importieren",
  "ci2.paso1": "1. Datei vorbereiten",
  "ci2.explicacion":
    "Eine CSV mit einer Zeile pro Produkt. Nötig sind mindestens „Produkt“, „Kategorie“ und „Preis“ (pro Gramm, oder pro Stück bei den Kategorien, die nach Stück gehen). Es versteht auch die Namen, die andere Programme verwenden, und die auf Spanisch, Katalanisch, Englisch und Niederländisch: „Bezeichnung“, „Preis“, „Price“, „Precio“ oder „Prijs“ gehen alle. Steht „Bestand“ dabei, kommt er als Eingangscharge herein, mit „Einkaufspreis“, „Lieferant“, „Charge“ und „MHD“, wenn du sie angibst. Der Rest (THC, CBD, Genetik, Mindestbestand, Marke, Beschreibung, Aktiv) wird übernommen, wenn er da ist.",
  "ci2.formatos":
    "Die Kategorien müssen schon im Sortiment stehen, mit ihrer Einheit: so legt ein Tippfehler keine neue Kategorie an. Zahlen mit Komma oder mit Punkt („8,50“ oder „8.5“); Datum 2027-03-01 oder 01/03/2027; Trennzeichen „;“ oder „,“. Dateien aus Excel werden angenommen.",
  "ci2.descargarPlantilla": "Vorlage herunterladen",
  "ci2.falloPlantilla": "Vorlage konnte nicht heruntergeladen werden",
  "ci2.paso2": "2. Datei auswählen und prüfen",
  "ci2.analizarNoGuarda": "Prüfen speichert nichts: es kontrolliert nur die Datei und sagt dir, was es findet.",
  "ci2.analizando": "Wird geprüft...",
  "ci2.analizar": "Prüfen",
  "ci2.paso3": "3. Ergebnis",
  "ci2.procesando": "Datei wird verarbeitet...",
  "ci2.eligeFichero": "Wähle eine Datei und drücke Prüfen.",
  "ci2.filas": "Zeilen",
  "ci2.validas": "Gültig",
  "ci2.conErrores": "Mit Fehlern",
  "ci2.columnas": "Erkannte Spalten: {columnas}",
  "ci2.corrige":
    "Korrigier diese Zeilen in der Datei und prüf sie noch einmal. Solange es Fehler gibt, wird nichts importiert.",
  "ci2.fila": "Zeile",
  "ci2.problema": "Problem",
  "ci2.producto": "Produkt",
  "ci2.categoria": "Kategorie",
  "ci2.precio": "Pauschale",
  "ci2.stock": "Bestand",
  "ci2.seMuestran": "Es werden {cuantos} von {total} angezeigt.",
  "ci2.importarUno": "1 Produkt importieren",
  "ci2.importarVarios": "{n} Produkte importieren",
  "ci2.conStock": " ({n} mit Bestand)",
  "ci2.falloLeer": "Datei konnte nicht gelesen werden",
  "ci2.falloImportar": "Konnte nicht importiert werden",

  "di.titulo": "Öffnungstage",
  "di.descripcion": "An welchen Tagen der Club offen war und wie jeder Tag lief",
  "di.a": "bis",
  "di.unDiaSinCerrar": "1 Tag ohne Kassenabschluss.",
  "di.diasSinCerrar": "{n} Tage ohne Kassenabschluss.",
  "di.arqueoNoCuadra": "Der Kassensturz dieser Tage stimmt erst, wenn sie abgeschlossen sind.",
  "di.irACaja": "Zur Kasse",
  "di.diasAbiertos": "Geöffnete Tage",
  "di.deTantos": "{abiertos} von {total}",
  "di.delPeriodo": "Im gewählten Zeitraum",
  "di.entradoEnTotal": "Insgesamt eingenommen",
  "di.entregasBarraCuotas": "Abgaben, Tresen und Mitgliedsbeiträge",
  "di.sociosDistintos": "Verschiedene Mitglieder",
  "di.hanPasado": "Waren im Club",
  "di.soloAbiertos": "Nur die Tage, an denen wir offen hatten",
  "di.cuandoCuentaAbierto":
    "Ein Tag zählt als geöffnet, sobald jemand eingelassen wird, etwas abgegeben, am Tresen kassiert oder eine Kasse geöffnet wird.",
  "di.noAbrioNinguno": "Der Club hatte in diesem Zeitraum an keinem Tag offen.",
  "di.sinDias": "Im gewählten Zeitraum gibt es keine Tage.",
  "di.dia": "Tag",
  "di.socios": "Mitglieder",
  "di.entregas": "Abgaben",
  "di.dispensado": "Abgegeben",
  "di.barra": "Tresen",
  "di.cuotas": "Mitgliedsbeiträge",
  "di.total": "Gesamt",
  "di.caja": "Kasse",
  "di.cerrado": "Abgeschlossen",
  "di.unAlta": "1 Aufnahme",
  "di.altas": "{n} Aufnahmen",
  "di.sinCaja": "Keine Kasse",
  "di.sinCerrar": "Nicht abgeschlossen",
  "di.cuadro": "Stimmt",
  "di.notaTotal":
    "Die Summe umfasst Abgaben, Tresen und Mitgliedsbeiträge. Aufladungen aufs Guthabenkonto sind nicht dabei, das Geld gehört noch dem Mitglied, und Ausgaben werden nicht abgezogen.",
  "di.diaYNumero": "{dia} {numero}",

  "ac.titulo": "Einlasskontrolle",
  "ac.descripcion": "Kommen und Gehen der Mitglieder im Clubraum",
  "ac.fallo": "Einlass konnte nicht erfasst werden",
  "ac.registrarEntrada": "Einlass erfassen",
  "ac.identificar": "Mitglied identifizieren...",
  "ac.alElegir":
    "Wählst du ein Mitglied aus, wird sein Einlass erfasst. Ist seine Mitgliedschaft abgelaufen oder ist es gesperrt, warnt das System und lässt es nicht herein.",
  "ac.socioNumero": "Mitglied #{numero}",
  "ac.accesoRegistrado": "Einlass erfasst",
  "ac.cartera": "Guthaben: {importe}",
  "ac.cuotaValida": "Mitgliedschaft gültig bis {fecha}",
  "ac.irAlMostrador": "Zur Theke",
  "ac.dentroAhora": "Jetzt im Club",
  "ac.accesosHoy": "Einlässe heute",
  "ac.enElLocal": "Mitglieder im Clubraum",
  "ac.nadieDentro": "Es ist niemand im Clubraum erfasst.",
  "ac.desde": "seit {hora}",
  "ac.deHoy": "Einlässe von heute",
  "ac.ningunoHoy": "Heute wurde noch kein Einlass erfasst.",
  "ac.hora": "Uhrzeit",
  "ac.socio": "Mitglied",
  "ac.tipo": "Art",
  "ac.entrada": "Eingang",
  "ac.salida": "Ausgang",

  "co2.titulo": "Mitgliedsvertrag",
  "co2.descripcion": "Die eidesstattliche Erklärung und die Regeln, die bei der Aufnahme unterschrieben werden",
  "co2.fallo": "Vertrag konnte nicht gespeichert werden",
  "co2.sinCambios": "Du hast nichts geändert: es bleibt bei Version {numero}.",
  "co2.guardadoConRaros":
    "Als Version {numero} gespeichert. Achtung: {huecos} kann ich nicht ausfüllen und steht so im Dokument.",
  "co2.guardado": "Als Version {numero} gespeichert.",
  "co2.sinEscribir":
    "Du hast den Vertrag noch nicht geschrieben. Bis dahin gibt es bei der Aufnahme nichts zu unterschreiben und das Mitglied sieht ihn auch nicht im Mitgliederbereich.",
  "co2.versionActual": "Aktuelle Version",
  "co2.numeroVersion": "Nr. {numero}",
  "co2.publicada": "Veröffentlicht {fecha}",
  "co2.sinEscribirPie": "Nicht geschrieben",
  "co2.loHanFirmado": "Haben unterschrieben",
  "co2.contandoVersiones": "Mitglieder, über alle Versionen gerechnet",
  "co2.sinFirmar": "Nicht unterschrieben",
  "co2.faltanDeAlta": "Aufgenommene Mitglieder, die noch fehlen",
  "co2.ningunoPendiente": "Keine ausstehend",
  "co2.elTexto": "Der Text",
  "co2.elTextoDeHoy": "Der aktuelle Text",
  "co2.ejemplo": "Eidesstattliche Erklärung\n\nHerr/Frau {{NOMBRE}}, {{DNI}}, erklärt...",
  "co2.seGuardaTalCual":
    "Gespeichert wird genau so, wie du es schreibst, samt Zeilenumbrüchen. Jedes Mal, wenn du den Text änderst, entsteht eine neue Version; die alte bleibt, denn wer sie unterschrieben hat, hat genau die unterschrieben.",
  "co2.huecos": "Platzhalter, die du nutzen kannst",
  "co2.huecosAyuda":
    "Schreib sie in doppelte geschweifte Klammern, dann füllen sie sich mit den Daten des jeweiligen Mitglieds.",
  "co2.versiones": "Versionen",
  "co2.sinVersiones": "Noch keine da.",
  "co2.numero": "Nr.",
  "co2.publicadaColumna": "Veröffentlicht",
  "co2.firmas": "Unterschriften",
  "co2.ver": "Ansehen",
  "co2.sinFirmarCuantos": "Nicht unterschrieben ({n})",
  "co2.socioColumna": "Mitglied",
  "co2.deAltaDesde": "Mitglied seit",
  "co2.unSocioDeAntes": "1 Mitglied aus der Zeit vor dem Vertrag.",
  "co2.sociosDeAntes": "{n} Mitglieder aus der Zeit vor dem Vertrag.",
  "co2.seFirmaDesde":
    "Unterschrieben wird in der Mitgliedsakte, oder im Mitgliederbereich, wenn er für das Mitglied freigeschaltet ist.",
  "co2.v.titulo": "Vertrag · Version {numero}",
  "co2.v.publicadaEl": "Veröffentlicht am {fecha}.",

  "in.titulo": "Auswertungen",
  "in.descripcion": "Aktivität des Vereins im gewählten Zeitraum",
  "in.a": "bis",
  "in.porDia": "Pro Tag",
  "in.porMes": "Pro Monat",
  "in.aportaciones": "Pauschalen",
  "in.unaEntrega": "1 Abgabe",
  "in.entregas": "{n} Abgaben",
  "in.dispensado": "Abgegeben",
  "in.cuotasCobradas": "Kassierte Mitgliedsbeiträge",
  "in.unaCuota": "1 Mitgliedsbeitrag",
  "in.cuotas": "{n} Mitgliedsbeiträge",
  "in.gastos": "Ausgaben",
  "in.verDesglose": "Aufschlüsselung ansehen",
  "in.evolucion": "Entwicklung der abgegebenen Menge",
  "in.sinActividad": "In diesem Zeitraum ist nichts erfasst.",
  "in.unPeriodo": "1 Zeitraum",
  "in.periodos": "{n} Zeiträume",
  "in.masDispensados": "Am meisten abgegebene Produkte",
  "in.sinDatos": "Keine Daten im Zeitraum.",
  "in.producto": "Produkt",
  "in.cantidad": "Menge",
  "in.masActivos": "Aktivste Mitglieder",
  "in.socio": "Mitglied",
  "in.visitas": "Besuche",
  "in.queMasAportan": "Wer am meisten einbringt",
  "in.nadieHaAportado": "Im Zeitraum hat niemand etwas eingebracht.",
  "in.enGenero": "{importe} an Pauschalen",
  "in.enBarra": "{importe} am Tresen",
  "in.deCuota": "{importe} an Mitgliedsbeitrag",
  "in.donado": "{importe} gespendet",
  "in.noCuentaCartera":
    "Was sie auf ihr Guthabenkonto geladen haben, zählt nicht mit: das Geld gehört ihnen, bis sie es ausgeben.",
  "in.porFormaDePago": "Pauschalen nach Zahlungsart",
  "in.recargasCartera": "Aufladungen aufs Guthabenkonto",
  "in.queOpinan": "Was die Mitglieder meinen",
  "in.nota": "Note",
  "in.votos": "Stimmen",
  "in.queDicen": "Was sie schreiben",
  "in.nadieHaEscrito": "Noch hat niemand etwas geschrieben. Noten ohne Kommentar zählen trotzdem für den Schnitt.",

  "cm.titulo": "Gemeinschaft",
  "cm.descripcion": "Aufnahmeanträge und Neuigkeiten für den Mitgliederbereich",
  "cm.nuevaNoticia": "+ Neuigkeit",
  "cm.tabSolicitudes": "Anträge",
  "cm.tabNoticias": "Neuigkeiten",
  "cm.pendientes": "Ausstehend",
  "cm.resueltas": "Erledigt",
  "cm.enlaceAlta": "Link für den Aufnahmeantrag",
  "cm.copiarEnlace": "Link kopieren",
  "cm.solicitudesPendientes": "Ausstehende Anträge",
  "cm.sinPendientes": "Es gibt keine ausstehenden Anträge.",
  "cm.recibida": "Eingegangen",
  "cm.persona": "Person",
  "cm.contacto": "Kontakt",
  "cm.avalista": "Bürge",
  "cm.nacidoEl": "{documento} · geboren am {fecha}",
  "cm.socioNumero": "Mitglied Nr. {numero}",
  "cm.aprobar": "Annehmen",
  "cm.rechazar": "Ablehnen",
  "cm.aprobada": "{persona} ist jetzt Mitglied Nr. {numero}, der Mitgliedsbeitrag steht noch aus.",
  "cm.falloAprobar": "Konnte nicht angenommen werden",
  "cm.estado": "Status",
  "cm.resultado": "Ergebnis",
  "cm.etiquetaAprobada": "Angenommen",
  "cm.etiquetaRechazada": "Abgelehnt",
  "cm.sinNoticias": "Keine Neuigkeiten. Veröffentlich eine und die Mitglieder sehen sie im Mitgliederbereich.",
  "cm.fecha": "Datum",
  "cm.tituloColumna": "Titel",
  "cm.publicadoPor": "Veröffentlicht von",
  "cm.publicada": "Veröffentlicht",
  "cm.borrador": "Entwurf",
  "cm.editar": "Bearbeiten",
  "cm.borrar": "Löschen",
  "cm.confirmarBorrar": "„{titulo}“ löschen?",
  "cm.n.editar": "Neuigkeit bearbeiten",
  "cm.n.nueva": "Neuigkeit schreiben",
  "cm.n.fallo": "Neuigkeit konnte nicht gespeichert werden",
  "cm.n.titulo": "Titel",
  "cm.n.texto": "Text",
  "cm.n.textoAyuda": "Die Mitglieder sehen das im Mitgliederbereich.",
  "cm.n.publicada": "Veröffentlicht (Haken weg, dann bleibt sie ein Entwurf)",
  "cm.n.avisar": "Mitglieder aufs Handy benachrichtigen",
  "cm.n.avisarAyuda": "Kommt nur bei denen an, die die Benachrichtigungen im Mitgliederbereich eingeschaltet haben.",
  "cm.n.fotos": "Fotos",
  "cm.n.quitar": "Entfernen",
  "cm.n.subiendo": "Wird hochgeladen…",
  "cm.n.otraFoto": "Weiteres Foto hinzufügen",
  "cm.n.anadirFotos": "Fotos hinzufügen",
  "cm.n.escribePrimero":
    "Schreib zuerst Titel und Text: Die Neuigkeit wird gespeichert, sobald du das erste Foto hinzufügst.",
  "cm.n.hastaOcho": "Bis zu 8 Fotos. JPG, PNG oder WEBP.",
  "cm.n.falloSubir": "Foto konnte nicht hochgeladen werden",
  "cm.n.falloQuitar": "Foto konnte nicht entfernt werden",
  "cm.r.titulo": "Aufnahmeantrag von {nombre} ablehnen",
  "cm.r.rechazar": "Ablehnen",
  "cm.r.fallo": "Konnte nicht abgelehnt werden",
  "cm.r.queda":
    "Der Antrag wird archiviert. Der Grund ist nur für eure Unterlagen: Das Programm benachrichtigt die Person nicht.",
  "cm.r.motivo": "Grund (optional)",

  "aj.titulo": "Einstellungen",
  "aj.descripcion": "Vereinsdaten, Limits und Team",
  "aj.guardarCambios": "Änderungen speichern",
  "aj.guardados": "Einstellungen gespeichert.",
  "aj.fallo": "Einstellungen konnten nicht gespeichert werden",
  "aj.datos": "Vereinsdaten",
  "aj.nombre": "Name",
  "aj.cif": "Steuernummer",
  "aj.telefono": "Telefon",
  "aj.direccion": "Adresse",
  "aj.ciudad": "Stadt",
  "aj.provincia": "Bundesland",
  "aj.cp": "Postleitzahl",
  "aj.email": "Kontakt-E-Mail",
  "aj.reglas": "Abgaberegeln",
  "aj.limiteDiario": "Tageslimit (g)",
  "aj.limiteDiarioAyuda": "Pro Mitglied und Tag.",
  "aj.limiteMensual": "Monatslimit (g)",
  "aj.limiteMensualAyuda": "Pro Mitglied und Kalendermonat.",
  "aj.cuotaAnual": "Jahresbeitrag (Credits)",
  "aj.limitesPropios": "Jedes Mitglied kann eigene Limits haben, die diese hier ersetzen.",
  "aj.aforo": "Zulässige Personenzahl",
  "aj.aforoAyuda":
    "Wie viele Personen laut eurer Betriebsgenehmigung hineinpassen. Steht an der Theke neben der Zahl der Anwesenden. Lass es auf 0, wenn du das nicht kontrollieren willst.",
  "aj.aforoNota":
    "Ist die Zahl erreicht, gibt es einen Hinweis, aber der Einlass wird nicht gesperrt: Die Zählung hängt davon ab, dass die Leute beim Gehen erfasst werden, und einem Mitglied wegen einer Zahl, die nicht stimmen muss, die Tür zu weisen wäre schlimmer, als gar keine Zahl zu haben.",
  "aj.ticket": "Abgabebeleg",
  "aj.idiomaPortal": "Sprache des Mitgliederbereichs",
  "aj.idiomaPortalAyuda":
    "In dieser Sprache sehen die Mitglieder den Mitgliederbereich und bekommen die E-Mails zum Mitgliedsbeitrag. Jedes Mitglied kann sie am Handy ändern.",
  "aj.anchoPapel": "Papierbreite",
  "aj.anchoPapelAyuda": "Die des Thermodruckers an der Theke.",
  "aj.ancho80": "80 mm (Standard)",
  "aj.ancho58": "58 mm (schmal)",
  "aj.textoTicket": "Text auf dem Beleg",
  "aj.textoTicketAyuda": "Steht unten auf jedem Abgabebeleg.",
  "aj.avisoLegal": "Impressum",
  "aj.avisoCuota": "Automatische Beitragserinnerung",
  "aj.avisoCuotaNota":
    "Einmal am Tag erinnert das Programm die Mitglieder, deren Mitgliedschaft abläuft, per E-Mail (und aufs Handy, wenn sie den Mitgliederbereich installiert haben). Jedes Mitglied bekommt pro Mitgliedsbeitrag nur eine Erinnerung: Nach der Verlängerung ist es im nächsten Jahr wieder dabei.",
  "aj.avisarAuto": "Automatisch erinnern",
  "aj.cuantosDiasAntes": "Wie viele Tage vorher",
  "aj.cuantosDiasAyuda": "Wessen Mitgliedschaft schon abgelaufen ist, wird ebenfalls erinnert.",
  "aj.avisoApagado":
    "Das ist mit Absicht aus: Ob ihr euren Mitgliedern schreibt, entscheidet der Club, nicht das Programm. Unter Verlängerungen könnt ihr sie jederzeit von Hand verschicken, auch wenn das hier aus bleibt.",
  "aj.equipo": "Team",
  "aj.nuevoUsuario": "+ Benutzer",
  "aj.usuario": "Benutzer",
  "aj.rol": "Rolle",
  "aj.ultimoAcceso": "Letzter Zugriff",
  "aj.desactivado": "Deaktiviert",
  "aj.nunca": "Nie",
  "aj.permisosAMedida": "eigene Berechtigungen",

  "permiso.verSocios": "Mitgliederverzeichnis ansehen",
  "permiso.crearSocio": "Mitglieder aufnehmen",
  "permiso.editarSocio": "Mitgliedsakte bearbeiten",
  "permiso.registrarAcceso": "Einlässe erfassen",
  "permiso.cobrarCuota": "Mitgliedsbeiträge kassieren",
  "permiso.recargarCartera": "Guthabenkonto aufladen",
  "permiso.verCatalogo": "Sortiment ansehen",
  "permiso.venderBarra": "Am Tresen kassieren",
  "permiso.gestionarInventario": "Zugänge, Schwund und Inventuren",
  "permiso.anularDispensacion": "Abgaben stornieren",
  "permiso.suspenderSocio": "Mitglieder vorübergehend sperren",
  "permiso.gestionarCaja": "Kasse öffnen und abschließen",
  "permiso.gestionarGastos": "Ausgaben, Einkäufe und Spenden erfassen",
  "permiso.dispensar": "An der Theke abgeben",
  "permiso.descuentoManual": "Ermäßigungen von Hand geben",
  "permiso.moverGuardado": "Ware vom Lager an die Theke holen",
  "permiso.verInformes": "Auswertungen ansehen und exportieren",
  "permiso.ajustarCartera": "Guthaben auszahlen oder korrigieren",
  "permiso.gestionarPublicaciones": "Neuigkeiten veröffentlichen",
  "permiso.gestionarSolicitudes": "Aufnahmeanträge annehmen oder ablehnen",
  "permiso.gestionarCatalogo": "Produkte anlegen und bearbeiten",
  "permiso.gestionarBarra": "Getränkekarte verwalten",
  "permiso.anularCuota": "Kassierte Mitgliedsbeiträge stornieren",
  "permiso.gestionarUsuarios": "Team verwalten",
  "permiso.ajustesClub": "Clubeinstellungen ändern",
  "permiso.bajaSocio": "Mitgliedschaften beenden",
  "permiso.importarSocios": "Mitglieder aus CSV importieren",
  "permiso.importarProductos": "Sortiment und Bestand aus CSV importieren",
  "permiso.verAuditoria": "Aktivitätsprotokoll ansehen",
  "permiso.borrarDatos": "Mitgliedsdaten löschen",
  "permiso.copiaSeguridad": "Datensicherungen herunterladen",

  "aj.cs.titulo": "Alle abmelden",
  "aj.cs.explicacion":
    "Damit meldest du das ganze Team von allen Bildschirmen ab, dich eingeschlossen. Für eine einzelne Person brauchst du das hier nicht: Deaktiviere hier oben ihr Konto, dann ist sie genauso draußen.",
  "aj.cs.boton": "Das ganze Team abmelden",
  "aj.cs.queVaAPasar":
    "Jeder offene Bildschirm fragt wieder nach dem Passwort, sobald er das nächste Mal mit dem Server spricht — in ein paar Sekunden. Deiner auch.",
  "aj.cs.loPendiente":
    "Bereits abgerechnete Abgaben, die noch nicht gesendet wurden, gehen nicht verloren: Sie warten auf dem Tablet und gehen von selbst raus, sobald sich jemand wieder anmeldet.",
  "aj.cs.confirmar": "Alle abmelden",
  "aj.cs.cerrando": "Wird abgemeldet…",
  "aj.cs.fallo": "Das Team konnte nicht abgemeldet werden",
  "aj.editar": "Bearbeiten",
  "aj.tiposDeSocio": "Mitgliedsarten",
  "aj.nuevoTipo": "+ Mitgliedsart",
  "aj.sinTipos": "Keine Arten. Leg zum Beispiel „Helfer“ an, mit 10 % Ermäßigung und reduziertem Beitrag.",
  "aj.tipo": "Art",
  "aj.descuento": "Ermäßigung",
  "aj.cuota": "Mitgliedsbeitrag",
  "aj.dura": "Dauer",
  "aj.limites": "Limits",
  "aj.socios": "Mitglieder",
  "aj.laDelClub": "der des Clubs",
  "aj.losDelClub": "die des Clubs",
  "aj.limitesDiaMes": "{diario} / Tag · {mensual} / Monat",
  "aj.registro": "Aktivitätsprotokoll",
  "aj.sinRegistros": "Keine Einträge.",
  "aj.sistema": "System",
  "aj.copia": "Datensicherung",
  "aj.copiaNota":
    "Lad die Daten herunter und bewahre sie verschlüsselt außerhalb des Lokals auf. Die Fotos der Mitglieder liegen im Ordner „uploads“ auf dem Server und sind nicht dabei.",
  "aj.copiaDatos": "Clubdaten (JSON)",
  "aj.copiaBase": "Komplette Datenbank (.db)",
  "aj.falloCopia": "Datensicherung konnte nicht heruntergeladen werden",
  "aj.variosClubes":
    "Auf dieser Installation gibt es mehrere Clubs: Die komplette Sicherung des Servers macht, wer ihn verwaltet.",
  "aj.copiasAuto": "Automatische Sicherungen",
  "aj.copiasAutoNota": "Das Programm legt jede Nacht eine Sicherung an und bewahrt die der letzten 14 Tage auf.",
  "aj.sinCopiasAun":
    "Noch keine vorhanden: Die erste wird heute Nacht erstellt. Bewahr trotzdem ab und zu selbst eine außerhalb des Servers auf.",
  "aj.u.titulo": "Neuer Benutzer im Team",
  "aj.u.fallo": "Benutzer konnte nicht angelegt werden",
  "aj.u.crear": "Anlegen",
  "aj.u.nombre": "Name",
  "aj.u.email": "E-Mail",
  "aj.u.contrasena": "Passwort",
  "aj.u.minimo": "Mindestens 8 Zeichen.",
  "aj.u.rol": "Rolle",
  "aj.u.trabajadorLargo": "Teammitglied — der Alltag: Theke, Mitglieder, Lager und Kasse",
  "aj.e.titulo": "{nombre} bearbeiten",
  "aj.e.fallo": "Benutzer konnte nicht gespeichert werden",
  "aj.e.nombre": "Name",
  "aj.e.rol": "Rolle",
  "aj.e.puesto": "Kassenplatz",
  "aj.e.puestoAyuda":
    "Legt fest, in welche Kasse fließt, was diese Person einnimmt. Ohne Kassenplatz in die Kasse des Clubs.",
  "aj.e.sinPuesto": "Ohne Kassenplatz",
  "aj.e.nuevaContrasena": "Neues Passwort",
  "aj.e.nuevaContrasenaAyuda": "Leer lassen, wenn es nicht geändert werden soll. Mindestens 8 Zeichen.",
  "aj.e.cuentaActiva": "Konto aktiv",
  "aj.e.noTuPropia": "Du kannst dein eigenes Konto nicht deaktivieren.",
  "aj.e.desactivada": "Ein deaktiviertes Konto kann sich nicht anmelden, behält aber seinen Verlauf.",
  "aj.e.permisos": "Berechtigungen",
  "aj.e.permisosAyuda":
    "Die Rolle legt fest, was standardmäßig geht. Hier kannst du Ausnahmen für diese Person machen: Was du änderst, wird hervorgehoben.",
  "aj.e.concedido": "erteilt",
  "aj.e.retirado": "entzogen",
  "aj.e.volverAlRol": "Zurück zu den Berechtigungen der Rolle",
  "aj.t.editar": "{nombre} bearbeiten",
  "aj.t.nuevo": "Neue Mitgliedsart",
  "aj.t.fallo": "Mitgliedsart konnte nicht gespeichert werden",
  "aj.t.falloBorrar": "Mitgliedsart konnte nicht gelöscht werden",
  "aj.t.borrar": "Löschen",
  "aj.t.nombre": "Name",
  "aj.t.color": "Farbe",
  "aj.t.descripcion": "Beschreibung",
  "aj.t.descuento": "Allgemeine Ermäßigung (%)",
  "aj.t.descuentoAyuda":
    "Auf die Pauschale aus dem Sortiment, außer das Produkt hat für diese Art eine feste Pauschale.",
  "aj.t.cuota": "Jahresbeitrag (Credits)",
  "aj.t.cuotaAyuda": "Leer = der Beitrag des Clubs. 0 = kein Beitrag.",
  "aj.t.duracion": "Laufzeit (Monate)",
  "aj.t.duracionAyuda": "12 ist üblich. Bei 1 zahlt das Mitglied jeden Monat.",
  "aj.t.limiteDiario": "Tageslimit (g)",
  "aj.t.limiteDiarioAyuda": "Leer = das des Clubs.",
  "aj.t.limiteMensual": "Monatslimit (g)",
  "aj.t.orden": "Reihenfolge",
  "aj.t.activo": "Aktiv (kann neuen Mitgliedern zugewiesen werden)",
  "aj.p.titulo": "Kassenplätze",
  "aj.p.nota":
    "Wenn im Club an mehr als einer Stelle gleichzeitig kassiert wird — an der Theke und am Tresen, jede mit eigener Schublade —, leg für jede einen Kassenplatz an und weise jeder Person im Team ihren zu. Jeder Kassenplatz öffnet seine eigene Kasse und macht seinen eigenen Kassenabschluss.",
  "aj.p.nota2": "Wenn du keinen anlegst, bleibt alles wie bisher: eine einzige Kasse für den ganzen Club.",
  "aj.p.inactivo": " · inaktiv",
  "aj.p.unaPersona": "1 Person",
  "aj.p.personas": "{n} Personen",
  "aj.p.desactivar": "Deaktivieren",
  "aj.p.activar": "Aktivieren",
  "aj.p.falloCambiar": "Konnte nicht geändert werden",
  "aj.p.ejemplo": "Theke, Tresen...",
  "aj.p.anadir": "Hinzufügen",
  "aj.p.fallo": "Kassenplatz konnte nicht angelegt werden",

  "su.titulo": "Dein Abo",
  "su.prueba": "Im Testzeitraum",
  "su.pruebaCaducada": "Testzeitraum beendet",
  "su.alDia": "Bezahlt",
  "su.moroso": "Zahlung ausstehend",
  "su.suspendido": "Gesperrt",
  "su.sinCoste": "Kostenlos",
  "su.alMes": "{importe} pro Monat",
  "su.sinCuota": "Für diesen Club fällt keine Gebühr an: Du kannst das Programm nutzen, ohne etwas zu zahlen.",
  "su.bloqueado":
    "Das Abo ist schon {dias} nicht ausgeglichen, und das Programm ist im Nur-Lese-Modus. Ihr könnt alles ansehen und die Datensicherungen herunterladen; sobald die Zahlung erfasst ist, geht alles wieder.",
  "su.vencioAyer": "Ist gestern abgelaufen. Vorerst funktioniert alles weiter wie gewohnt.",
  "su.vencioHace": "Ist schon {dias} abgelaufen. Vorerst funktioniert alles weiter wie gewohnt.",
  "su.pruebaTermina": "Der Testzeitraum endet am {fecha}, {cuando}.",
  "su.periodoHasta": "Der bezahlte Zeitraum reicht bis zum {fecha}, {cuando}.",
  "su.hoy": "heute",
  "su.manana": "morgen",
  "su.enDias": "noch {dias}",
  "su.sinFecha": "Es ist kein Ablaufdatum hinterlegt.",
  "su.pagos": "Erfasste Zahlungen",
  "su.sinPagos": "Es ist noch keine Zahlung erfasst.",
  "su.fecha": "Datum",
  "su.importe": "Betrag",
  "su.cubreHasta": "Bezahlt bis",
  "su.forma": "Zahlungsart",
  "su.recibo": "Rechnung",
  "su.metodo.TRANSFERENCIA": "Überweisung",
  "su.metodo.EFECTIVO": "Bar",
  "su.metodo.DOMICILIACION": "Lastschrift",
  "su.metodo.TARJETA": "Karte",
  "su.metodo.OTRO": "Sonstiges",
  "su.r.imprimir": "Drucken oder als PDF speichern",
  "su.r.suscripcion": "Abonnement des Verwaltungsprogramms",
  "su.r.recibidoDe": "Erhalten von",
  "su.r.fechaDelPago": "Zahlungsdatum",
  "su.r.concepto": "Verwendungszweck",
  "su.r.conceptoTexto": "Abonnement des Verwaltungsprogramms, bis zum {fecha}",
  "su.r.formaDePago": "Zahlungsart",
  "su.r.importe": "Betrag",
  "su.r.justificante":
    "Nachweis über die erfasste Zahlung. Er ersetzt nicht die Rechnung, die der Anbieter der Leistung ausstellt.",

  "en.titulo": "Clubverwaltung",
  "en.subtitulo": "Melde dich mit deinem Teamkonto an",
  "en.email": "E-Mail",
  "en.contrasena": "Passwort",
  "en.club": "Club",
  "en.eligeClub": "Club auswählen...",
  "en.variosClubes": "Diese E-Mail gehört zu mehreren Clubs: Wähl einen aus.",
  "en.entrando": "Anmeldung läuft...",
  "en.cola.una":
    "Auf diesem Tablet ist noch eine Abgabe nicht gesendet: Sie wurde ohne Verbindung gemacht und geht raus, sobald du dich anmeldest.",
  "en.cola.varias":
    "Auf diesem Tablet sind noch {cuantas} nicht gesendet: Sie wurden ohne Verbindung gemacht und gehen raus, sobald du dich anmeldest.",
  "en.entrar": "Anmelden",
  "en.fallo": "Anmeldung fehlgeschlagen",
  "en.olvidada": "Passwort vergessen",
  "en.aunNoEsta": "Euer Club ist noch nicht dabei?",
  "en.darloDeAlta": "Club anlegen",
  "en.queEs": "Was ist asocis",

  "rc.titulo": "Passwort vergessen",
  "rc.subtitulo": "Wir schicken dir einen Link an die E-Mail deines Kontos",
  "rc.email": "E-Mail",
  "rc.enviando": "Wird gesendet...",
  "rc.enviar": "Link schicken",
  "rc.fallo": "E-Mail konnte nicht gesendet werden",
  "rc.miraSpam": "Schau auch im Spam-Ordner nach. Der Link läuft in einer Stunde ab.",
  "rc.volver": "Zurück zur Anmeldung",
  "rc.nueva": "Neues Passwort",
  "rc.cambiada": "Passwort geändert. Weiter zur Anmeldung...",
  "rc.entrarAhora": "Jetzt anmelden",
  "rc.nuevaEtiqueta": "Neues Passwort",
  "rc.minimo": "Mindestens 8 Zeichen.",
  "rc.repitela": "Wiederholen",
  "rc.noCoinciden": "Die beiden Passwörter stimmen nicht überein.",
  "rc.cambiar": "Passwort ändern",
  "rc.falloCambiar": "Passwort konnte nicht geändert werden",

  "rg.cerrado": "Anlegen von Clubs geschlossen",
  "rg.cerradoTexto":
    "Auf dieser Installation lassen sich keine neuen Clubs über die Website anlegen. Sprich mit der Person, die den Server verwaltet, damit sie dir Zugang gibt.",
  "rg.volverAEntrar": "Zurück zur Anmeldung",
  "rg.titulo": "Club anlegen",
  "rg.subtitulo": "Du legst den Verein und dein Vorstandskonto an",
  "rg.nombreClub": "Name des Vereins",
  "rg.nombreClubEjemplo": "Anbauvereinigung...",
  "rg.ciudad": "Stadt",
  "rg.tuNombre": "Dein Name",
  "rg.tuEmail": "Deine E-Mail",
  "rg.tuEmailAyuda": "Damit meldest du dich an.",
  "rg.contrasena": "Passwort",
  "rg.minimo": "Mindestens 8 Zeichen.",
  "rg.repite": "Passwort wiederholen",
  "rg.codigo": "Lizenzcode",
  "rg.codigoAyuda": "Den hast du beim Abschluss bekommen. Er sieht so aus: ASOC-XXXX-XXXX.",
  "rg.acepto": "Ich habe gelesen und akzeptiere das",
  "rg.avisoLegal": "Impressum",
  "rg.yLa": "und die",
  "rg.privacidad": "Datenschutzerklärung",
  "rg.creando": "Club wird angelegt...",
  "rg.crear": "Club anlegen",
  "rg.yaTeneis": "Habt ihr schon einen Club?",
  "rg.entrar": "Anmelden",
  "rg.noCoinciden": "Die beiden Passwörter stimmen nicht überein",
  "rg.fallo": "Club konnte nicht angelegt werden",
};
